// 提单编辑公用页面
<template>
    <div class="main-center" style=": 80px;">
        <!--订舱信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../assets/image/icon/order1.svg" alt="">
                <span>{{$t("bookingSpace.booking.blInfo")}}</span>
            </div>
            <div class="cardBody">
                <!--船舶信息【不可编辑】-->
                <div class="flex flex-space-around margin-bottom">
                    <!--船名【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.main.vesselCode')}}</span>
                        </div>
                        <el-input v-model="bookingHead.vesselCode"
                                  readonly/>
                    </div>
                    <!--航次【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.main.voyageNo')}}</span>
                        </div>
                        <el-input v-model="bookingHead.voyageNo"
                                  readonly/>
                    </div>
                    <!--航段【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.main.voyageLeg')}}</span>
                        </div>
                        <el-input v-model="bookingHead.voyageLeg"
                                  readonly/>
                    </div>
                    <!--开航日期【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.main.saillingDate')}}</span>
                        </div>
                        <el-date-picker v-model="bkRouting1.saillingDate" type="date" class="dateInput1"
                                        readonly/>
                    </div>
                </div>

                <!--订舱信息-->
                <div class="flex flex-space-around margin-bottom">
                    <!--订舱号【不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("bookingSpace.booking.bkNo")}}</span>
                        </div>
                        <el-input v-model="bookingHead.bkNo"
                                  readonly/>
                    </div>
                    <!--提单号【不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("bookingSpace.booking.blNo")}}</span>
                        </div>
                        <el-input v-model="bookingHead.blNo"
                                  readonly/>
                    </div>
                    <div class="inputName">
                        <!--提单状态【流程自动控制，不可编辑】-->
                        <div class="inputName-title">
                            <span>{{$t("bookingSpace.booking.blStatus")}}</span>
                        </div>
                        <el-select v-model="bookingHead.blStatus"
                                   disabled>
                            <el-option v-for="item in blStatusOptions"
                                       :key="item.codeValue"
                                       :label="getDisplayValue(item)"
                                       :value="item.codeValue">
                                <span style="float: left">{{item.displayValueCn}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inputName">
                        <!--订舱类型【不可编辑】-->
                        <div class="inputName-title">
                            <span>{{$t("bookingSpace.booking.bookingType")}}</span></div>
                        <el-select v-model="bookingHead.bookingType"
                                   disabled
                                   @focus="bookingTypeFocus">
                            <el-option v-for="item in bookingTypeOptions"
                                       :key="item.codeValue"
                                       :label="item.displayValueCn"
                                       :value="item.codeValue"/>
                        </el-select>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--运输条款【不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("bookingSpace.booking.transportationTerms")}}</span>
                        </div>
                        <el-select v-model="bookingHead.transportationTerms"
                                   disabled
                                   @focus="transportationTermsFocus">
                            <el-option v-for="item in transportationTermsOptions"
                                       :key="item.serviceModeCode"
                                       :label="item.serviceModeCode"
                                       :value="item.serviceModeCode">
                                <span style="float: left">{{item.serviceModeCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.serviceModeDesc}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--付费方式【不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("bookingSpace.booking.paidType")}}</span>
                        </div>
                        <el-select v-model="bookingHead.paidType"
                                   disabled
                                   @focus="paidTypeFocus">
                            <el-option v-for="item in paidTypeOptions"
                                       :key="item.codeValue"
                                       :label="item.displayValueCn"
                                       :value="item.codeValue">
                                <span style="float: left">{{item.displayValueCn}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inputName">
                        <!--船开前协议号-->
                        <div class="inputName-title">
                            <span class="blueColor">{{$t("bookingSpace.booking.agreementNo")}}</span>
                        </div>
                        <el-input v-model="bookingHead.agreementNo"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999"
                                  clearable
                                  @input="formatUpperNoChinese('bookingHead','agreementNo',bookingHead.agreementNo,0,50)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bookingHead.agreementNo || '').length }}/50</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bookingHead.agreementNo']" class="field-error-tip">
                            {{fieldErrors['bookingHead.agreementNo']}}
                        </div>
                    </div>
                    <!--所属片区-->
                    <div class="inputName">
                      <div class="inputName-title">
                        <span>{{$t("bookingSpace.booking.sales")}}</span>
                      </div>
                      <el-input v-model="bookingHead.sales"
                                :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                :maxlength="9999"
                                clearable
                                @input="handleSalesInput">
                        <template slot="suffix">
                          <span class="custom-word-limit">{{ (bookingHead.agreementNo || '').length }}/50</span>
                        </template>
                      </el-input>
                      <div v-if="fieldErrors['bookingHead.sales']" class="field-error-tip">
                        {{fieldErrors['bookingHead.sales']}}
                      </div>
                    </div>
                    <!--询价单位 【取自客户代码，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("bookingSpace.booking.applicantUnit")}}</span>
                        </div>
                      <el-input v-model="bkExtend.applicantUnit"
                                readonly/>
                    </div>
                </div>
                <!--地点信息-->
                <div class="flex flex-space-around margin-bottom">
                    <div class="inputName">
                        <!--接货地【不可编辑】-->
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.por')}}</span>
                        </div>
                        <el-select v-model="bookingHead.por"
                                   disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inputName">
                        <!--装货港【取自船期，不可编辑】-->
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.portFrom')}}</span>
                        </div>
                        <el-select v-model="bookingHead.pol"
                                   disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="inputName">
                        <!--卸货港【取自船期，不可编辑】-->
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.portTo')}}</span>
                        </div>
                        <el-select v-model="bookingHead.pod"
                                   disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--目的地【不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.del')}}</span>
                        </div>
                        <el-select v-model="bookingHead.del"
                                   disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!--地点描述信息-->
                <div class="flex flex-space-around margin-bottom">
                    <!--接货地描述-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.porName')}}</span>
                        </div>
                        <el-input v-model="bkExtend.porName"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999"
                                  clearable
                                  @input="formatUpperNoChinese('bkExtend','porName',bkExtend.porName,0,50)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkExtend.porName || '').length }}/50</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkExtend.porName']" class="field-error-tip">
                            {{fieldErrors['bkExtend.porName']}}
                        </div>
                    </div>
                    <!--装货港描述-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.polName')}}</span>
                        </div>
                        <el-input v-model="bkExtend.polName"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999"
                                  clearable
                                  @input="formatUpperNoChinese('bkExtend','polName',bkExtend.polName,0,50)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkExtend.polName || '').length }}/50</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkExtend.polName']" class="field-error-tip">
                            {{fieldErrors['bkExtend.polName']}}
                        </div>
                    </div>
                    <!--卸货港描述-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.podName')}}</span>
                        </div>
                        <el-input v-model="bkExtend.podName"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999"
                                  clearable
                                  @input="formatUpperNoChinese('bkExtend','podName',bkExtend.podName,0,50)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkExtend.podName || '').length }}/50</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkExtend.podName']" class="field-error-tip">
                            {{fieldErrors['bkExtend.podName']}}
                        </div>
                    </div>
                    <!--目的地描述-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.delName')}}</span>
                        </div>
                        <el-input v-model="bkExtend.delName"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999"
                                  clearable
                                  @input="formatUpperNoChinese('bkExtend','delName',bkExtend.delName,0,50)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkExtend.delName || '').length }}/50</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkExtend.delName']" class="field-error-tip">
                            {{fieldErrors['bkExtend.delName']}}
                        </div>
                    </div>
                </div>
                <!--前程运输信息-->
                <div class="flex flex-space-around margin-bottom">
                    <!--支线船名-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchVesselCode')}}</span>
                        </div>
                        <el-input v-model="bkRoutingPre.vesselName"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999"
                                  @input="formatUpperNoChinese('bkRoutingPre','vesselName',bkRoutingPre.vesselName,0,50)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkRoutingPre.vesselName || '').length }}/50</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkRoutingPre.vesselName']" class="field-error-tip">
                            {{fieldErrors['bkRoutingPre.vesselName']}}
                        </div>
                    </div>
                    <!--支线航次-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchVoyageNo')}}</span>
                        </div>
                        <el-input v-model="bkRoutingPre.voyageNo"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999"
                                  @input="formatUpperNoChinese('bkRoutingPre','voyageNo',bkRoutingPre.voyageNo,0,20)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkRoutingPre.voyageNo || '').length }}/20</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkRoutingPre.voyageNo']" class="field-error-tip">
                            {{fieldErrors['bkRoutingPre.voyageNo']}}
                        </div>
                    </div>
                    <!--支线航段-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchVoyageLeg')}}</span>
                        </div>
                        <el-input v-model="bkRoutingPre.voyageLeg"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999"
                                  @input="formatUpperNoChinese('bkRoutingPre','voyageLeg',bkRoutingPre.voyageLeg,0,5)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkRoutingPre.voyageLeg || '').length }}/5</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkRoutingPre.voyageLeg']" class="field-error-tip">
                            {{fieldErrors['bkRoutingPre.voyageLeg']}}
                        </div>
                    </div>
                    <!--支线开航时间-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchSaillingDate')}}</span>
                        </div>
                        <el-date-picker v-model="bkRoutingPre.saillingDate" type="date" class="dateInput1"
                                        :placeholder="$t('common.pleaseSelectDate')"
                                        clearable/>
                    </div>
                    <!--支线承运人-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchCarrier')}}</span>
                        </div>
                        <el-select v-model="bkRoutingPre.carrier"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable filterable default-first-option
                                   allow-create
                                   @focus="carrierFocus">
                            <el-option v-for="item in carrierOptions"
                                       :key="item.codeValue"
                                       :label="item.codeValue"
                                       :value="item.codeValue">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!--【注释】-->
                <div style="font-size: 14px;margin-bottom: 5px">
                    <span class="redColor">{{$t('bookingSpace.branch.note')}}</span>
                </div>
            </div>
        </div>

        <!--提单信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../assets/image/icon/order2.svg" alt="">
                <span>{{$t('bookingSpace.bl.blInfo')}}</span>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around margin-bottom">
                    <div class="inputName">
                        <!--提单类型-->
                        <div class="inputName-title"><span class="redColor">{{$t('bookingSpace.bl.deliveryDocumentMethod')}}</span>
                        </div>
                        <el-select v-model="bookingHead.deliveryDocumentMethod"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable filterable default-first-option>
                            <el-option v-for="item in deliveryMethodOptions"
                                       :key="item.codeValue"
                                       :label="getDisplayValue(item)"
                                       :value="item.codeValue"
                                       :title="getFullMeaning(item)">
                            </el-option>
                        </el-select>
                    </div>
                    <!--签单地点-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.bl.deliveryDocumentPlace')}}</span>
                        </div>
                        <el-select v-model="bookingHead.deliveryDocumentPlace"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable filterable default-first-option
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--签单份数【默认为3份，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.bl.deliveryDocumentQuantity')}}</span>
                        </div>
                        <el-input v-model.number="bookingHead.deliveryDocumentQuantity"
                                  disabled/>
                    </div>
                    <!--付费地点【不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.bl.paidPalce')}}</span>
                        </div>
                        <el-select v-model="bookingHead.paidPalce"
                                   disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>

        <!--人员信息卡片【分两栏左右显示】-->
        <div class="cardBox">
            <el-row>
                <!--1.发货人信息-->
                <el-col style="width: 50%;">
                    <div class="cardTitle flex flex-align">
                        <img src="../../assets/image/icon/order3.svg" alt="">
                        <span>{{$t('bookingSpace.shipperInfo')}}</span>
                    </div>
                    <div class="cardBody">
                        <!--发货人客户名称-->
                        <div class="flex flex-space-around margin-bottom">
                            <div class="flex inputName ">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.shipper')}}</span>
                                </div>
                                <div style="position: relative; width: 100%;">
                                    <el-input v-model="shipper.customerName" type="textarea" :rows="3"
                                              :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                              :maxlength="9999"
                                              @input="formatUpperNoChinese('shipper','customerName',shipper.customerName,0,210)"/>
                                    <div class="textarea-word-limit">{{ (shipper.customerName || '').length }}/210</div>
                                </div>
                                <div v-if="fieldErrors['shipper.customerName']" class="field-error-tip">
                                    {{fieldErrors['shipper.customerName']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.addressPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.address')}}</span>
                                </div>
                                <el-input v-model="shipper.address"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','address',shipper.address)"/>
                                <div v-if="fieldErrors['shipper.address']" class="field-error-tip">
                                    {{fieldErrors['shipper.address']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.cityPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.city')}}</span>
                                </div>
                                <el-input v-model="shipper.city"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','city',shipper.city)"/>
                                <div v-if="fieldErrors['shipper.city']" class="field-error-tip">
                                    {{fieldErrors['shipper.city']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.provinceCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.provinceCode')}}</span>
                                </div>
                                <el-input v-model="shipper.provinceCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','provinceCode',shipper.provinceCode)"/>
                                <div v-if="fieldErrors['shipper.provinceCode']" class="field-error-tip">
                                    {{fieldErrors['shipper.provinceCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.provinceNamePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.provinceName')}}</span>
                                </div>
                                <el-input v-model="shipper.provinceName"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','provinceName',shipper.provinceName)"/>
                                <div v-if="fieldErrors['shipper.provinceName']" class="field-error-tip">
                                    {{fieldErrors['shipper.provinceName']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.postCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.postCode')}}</span>
                                </div>
                                <el-input v-model="shipper.postCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','postCode',shipper.postCode)"/>
                                <div v-if="fieldErrors['shipper.postCode']" class="field-error-tip">
                                    {{fieldErrors['shipper.postCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.countryCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.countryCode')}}</span>
                                </div>
                                <el-input v-model="shipper.countryCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','countryCode',shipper.countryCode)"/>
                                <div v-if="fieldErrors['shipper.countryCode']" class="field-error-tip">
                                    {{fieldErrors['shipper.countryCode']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.telPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.tel')}}</span>
                                </div>
                                <el-input v-model="shipper.tel"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','tel',shipper.tel)"/>
                                <div v-if="fieldErrors['shipper.tel']" class="field-error-tip">
                                    {{fieldErrors['shipper.tel']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.emailPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.email')}}</span>
                                </div>
                                <el-input v-model="shipper.email"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','email',shipper.email)"/>
                                <div v-if="fieldErrors['shipper.email']" class="field-error-tip">
                                    {{fieldErrors['shipper.email']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.enterpriseCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.enterpriseCode')}}</span>
                                </div>
                                <el-input v-model="shipper.enterpriseCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('shipper','enterpriseCode',shipper.enterpriseCode)"/>
                                <div v-if="fieldErrors['shipper.enterpriseCode']" class="field-error-tip">
                                    {{fieldErrors['shipper.enterpriseCode']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <!--收货人信息-->
                <el-col style="width: 50%;">
                    <div class="cardTitle flex flex-align">
                        <img src="../../assets/image/icon/order4.svg" alt="">
                        <span>{{$t('bookingSpace.consigneeInfo')}}</span>
                    </div>
                    <div class="cardBody">
                        <!--收货人客户名称-->
                        <div class="flex flex-space-around margin-bottom">
                            <div class="flex inputName ">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.consignee')}}</span>
                                </div>
                                <div style="position: relative; width: 100%;">
                                    <el-input v-model="consignee.customerName" type="textarea" :rows="3"
                                              :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                              :maxlength="9999"
                                              @input="formatUpperNoChinese('consignee','customerName',consignee.customerName,0,245)"/>
                                    <div class="textarea-word-limit">{{ (consignee.customerName || '').length }}/245</div>
                                </div>
                                <div v-if="fieldErrors['consignee.customerName']" class="field-error-tip">
                                    {{fieldErrors['consignee.customerName']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.addressPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.address')}}</span>
                                </div>
                                <el-input v-model="consignee.address"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','address',consignee.address)"/>
                                <div v-if="fieldErrors['consignee.address']" class="field-error-tip">
                                    {{fieldErrors['consignee.address']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.cityPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.city')}}</span>
                                </div>
                                <el-input v-model="consignee.city"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','city',consignee.city)"/>
                                <div v-if="fieldErrors['consignee.city']" class="field-error-tip">
                                    {{fieldErrors['consignee.city']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.provinceCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.provinceCode')}}</span>
                                </div>
                                <el-input v-model="consignee.provinceCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','provinceCode',consignee.provinceCode)"/>
                                <div v-if="fieldErrors['consignee.provinceCode']" class="field-error-tip">
                                    {{fieldErrors['consignee.provinceCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.provinceNamePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.provinceName')}}</span>
                                </div>
                                <el-input v-model="consignee.provinceName"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','provinceName',consignee.provinceName)"/>
                                <div v-if="fieldErrors['consignee.provinceName']" class="field-error-tip">
                                    {{fieldErrors['consignee.provinceName']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.postCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.postCode')}}</span>
                                </div>
                                <el-input v-model="consignee.postCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','postCode',consignee.postCode)"/>
                                <div v-if="fieldErrors['consignee.postCode']" class="field-error-tip">
                                    {{fieldErrors['consignee.postCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.countryCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.countryCode')}}</span>
                                </div>
                                <el-input v-model="consignee.countryCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','countryCode',consignee.countryCode)"/>
                                <div v-if="fieldErrors['consignee.countryCode']" class="field-error-tip">
                                    {{fieldErrors['consignee.countryCode']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.telPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.tel')}}</span>
                                </div>
                                <el-input v-model="consignee.tel"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','tel',consignee.tel)"/>
                                <div v-if="fieldErrors['consignee.tel']" class="field-error-tip">
                                    {{fieldErrors['consignee.tel']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.emailPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.email')}}</span>
                                </div>
                                <el-input v-model="consignee.email"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','email',consignee.email)"/>
                                <div v-if="fieldErrors['consignee.email']" class="field-error-tip">
                                    {{fieldErrors['consignee.email']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.enterpriseCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.enterpriseCode')}}</span>
                                </div>
                                <el-input v-model="consignee.enterpriseCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('consignee','enterpriseCode',consignee.enterpriseCode)"/>
                                <div v-if="fieldErrors['consignee.enterpriseCode']" class="field-error-tip">
                                    {{fieldErrors['consignee.enterpriseCode']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <!--通知人1信息-->
                <el-col style="width: 50%;margin-top: 5px">
                    <div class="cardTitle flex flex-align">
                        <img src="../../assets/image/icon/order5.svg" alt="">
                        <span>{{$t('bookingSpace.notify1Info')}}</span>
                    </div>
                    <div class="cardBody">
                        <!--通知人1客户名称-->
                        <div class="flex flex-space-around margin-bottom">
                            <div class="flex inputName ">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.notifier1')}}</span>
                                </div>
                                <div style="position: relative; width: 100%;">
                                    <el-input v-model="notifier1.customerName" type="textarea" :rows="3"
                                              :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                              :maxlength="9999"
                                              @input="formatUpperNoChinese('notifier1','customerName',notifier1.customerName,0,245)"/>
                                    <div class="textarea-word-limit">{{ (notifier1.customerName || '').length }}/245</div>
                                </div>
                                <div v-if="fieldErrors['notifier1.customerName']" class="field-error-tip">
                                    {{fieldErrors['notifier1.customerName']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.addressPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.address')}}</span>
                                </div>
                                <el-input v-model="notifier1.address"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','address',notifier1.address)"/>
                                <div v-if="fieldErrors['notifier1.address']" class="field-error-tip">
                                    {{fieldErrors['notifier1.address']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.cityPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.city')}}</span>
                                </div>
                                <el-input v-model="notifier1.city"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','city',notifier1.city)"/>
                                <div v-if="fieldErrors['notifier1.city']" class="field-error-tip">
                                    {{fieldErrors['notifier1.city']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.provinceCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.provinceCode')}}</span>
                                </div>
                                <el-input v-model="notifier1.provinceCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','provinceCode',notifier1.provinceCode)"/>
                                <div v-if="fieldErrors['notifier1.provinceCode']" class="field-error-tip">
                                    {{fieldErrors['notifier1.provinceCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.provinceNamePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.provinceName')}}</span>
                                </div>
                                <el-input v-model="notifier1.provinceName"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','provinceName',notifier1.provinceName)"/>
                                <div v-if="fieldErrors['notifier1.provinceName']" class="field-error-tip">
                                    {{fieldErrors['notifier1.provinceName']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.postCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.postCode')}}</span>
                                </div>
                                <el-input v-model="notifier1.postCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','postCode',notifier1.postCode)"/>
                                <div v-if="fieldErrors['notifier1.postCode']" class="field-error-tip">
                                    {{fieldErrors['notifier1.postCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.countryCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.countryCode')}}</span>
                                </div>
                                <el-input v-model="notifier1.countryCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','countryCode',notifier1.countryCode)"/>
                                <div v-if="fieldErrors['notifier1.countryCode']" class="field-error-tip">
                                    {{fieldErrors['notifier1.countryCode']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.telPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.tel')}}</span>
                                </div>
                                <el-input v-model="notifier1.tel"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','tel',notifier1.tel)"/>
                                <div v-if="fieldErrors['notifier1.tel']" class="field-error-tip">
                                    {{fieldErrors['notifier1.tel']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.emailPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.email')}}</span>
                                </div>
                                <el-input v-model="notifier1.email"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','email',notifier1.email)"/>
                                <div v-if="fieldErrors['notifier1.email']" class="field-error-tip">
                                    {{fieldErrors['notifier1.email']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.enterpriseCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.enterpriseCode')}}</span>
                                </div>
                                <el-input v-model="notifier1.enterpriseCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier1','enterpriseCode',notifier1.enterpriseCode)"/>
                                <div v-if="fieldErrors['notifier1.enterpriseCode']" class="field-error-tip">
                                    {{fieldErrors['notifier1.enterpriseCode']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <!--通知人2信息-->
                <el-col style="width: 50%;margin-top: 5px">
                    <div class="cardTitle flex flex-align">
                        <img src="../../assets/image/icon/order5.svg" alt="">
                        <span>{{$t('bookingSpace.notify2Info')}}</span>
                    </div>
                    <div class="cardBody">
                        <!--通知人2客户名称-->
                        <div class="flex flex-space-around margin-bottom">
                            <div class="inputName ">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.notifier2')}}</span>
                                </div>
                                <div style="position: relative; width: 100%;">
                                    <el-input v-model="notifier2.customerName" type="textarea" :rows="3"
                                              :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                              :maxlength="9999"
                                              @input="formatUpperNoChinese('notifier2','customerName',notifier2.customerName,0,245)"/>
                                    <div class="textarea-word-limit">{{ (notifier2.customerName || '').length }}/245</div>
                                </div>
                                <div v-if="fieldErrors['notifier2.customerName']" class="field-error-tip">
                                    {{fieldErrors['notifier2.customerName']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.addressPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.address')}}</span>
                                </div>
                                <el-input v-model="notifier2.address"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','address',notifier2.address)"/>
                                <div v-if="fieldErrors['notifier2.address']" class="field-error-tip">
                                    {{fieldErrors['notifier2.address']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.cityPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.city')}}</span>
                                </div>
                                <el-input v-model="notifier2.city"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','city',notifier2.city)"/>
                                <div v-if="fieldErrors['notifier2.city']" class="field-error-tip">
                                    {{fieldErrors['notifier2.city']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.provinceCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.provinceCode')}}</span>
                                </div>
                                <el-input v-model="notifier2.provinceCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','provinceCode',notifier2.provinceCode)"/>
                                <div v-if="fieldErrors['notifier2.provinceCode']" class="field-error-tip">
                                    {{fieldErrors['notifier2.provinceCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.provinceNamePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.provinceName')}}</span>
                                </div>
                                <el-input v-model="notifier2.provinceName"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','provinceName',notifier2.provinceName)"/>
                                <div v-if="fieldErrors['notifier2.provinceName']" class="field-error-tip">
                                    {{fieldErrors['notifier2.provinceName']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.postCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.postCode')}}</span>
                                </div>
                                <el-input v-model="notifier2.postCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','postCode',notifier2.postCode)"/>
                                <div v-if="fieldErrors['notifier2.postCode']" class="field-error-tip">
                                    {{fieldErrors['notifier2.postCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.countryCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.countryCode')}}</span>
                                </div>
                                <el-input v-model="notifier2.countryCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','countryCode',notifier2.countryCode)"/>
                                <div v-if="fieldErrors['notifier2.countryCode']" class="field-error-tip">
                                    {{fieldErrors['notifier2.countryCode']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.telPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.tel')}}</span>
                                </div>
                                <el-input v-model="notifier2.tel"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','tel',notifier2.tel)"/>
                                <div v-if="fieldErrors['notifier2.tel']" class="field-error-tip">
                                    {{fieldErrors['notifier2.tel']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.emailPrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.email')}}</span>
                                </div>
                                <el-input v-model="notifier2.email"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','email',notifier2.email)"/>
                                <div v-if="fieldErrors['notifier2.email']" class="field-error-tip">
                                    {{fieldErrors['notifier2.email']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.enterpriseCodePrintFlag" type="checkbox" :value=true />
                                    <span>{{$t('bookingSpace.customer.enterpriseCode')}}</span>
                                </div>
                                <el-input v-model="notifier2.enterpriseCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable
                                          @input="formatUpperNoChinese('notifier2','enterpriseCode',notifier2.enterpriseCode)"/>
                                <div v-if="fieldErrors['notifier2.enterpriseCode']" class="field-error-tip">
                                    {{fieldErrors['notifier2.enterpriseCode']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <!--【注释】*以上国家代码、联系电话、邮件地址、企业代码输入信息将不显示在提单上-->
                    <div style="font-size: 14px;margin-bottom: 5px">
                        <span class="redColor">{{$t('bookingSpace.customer.note')}}</span>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!--货物信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../assets/image/icon/order11.svg" alt="">
                <span>{{$t('bookingSpace.cargo.cargoInfo')}}</span>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around" style="height: 205px">
                    <div style="width:40%;margin-top:2px;">
                        <!--货描-->
                        <div class="inputName">
                            <div class="inputName-title">
                                <span class="redColor">{{$t('bookingSpace.cargo.cargoDesc')}}</span>
                            </div>
                            <div style="position: relative; width: 100%;">
                                <el-input v-model="bkCargo.cargoDesc" type="textarea" :rows="9"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                          :maxlength="isSGP ? undefined : 3990"
                                          @input="formatUpperNoChinese('bkCargo','cargoDesc',bkCargo.cargoDesc,0,isSGP ? null : 3990)"/>
                                <div class="textarea-word-limit">{{ (bkCargo.cargoDesc || '').length }}/{{isSGP ? '不限字数' : 3990}}</div>
                            </div>
                            <div v-if="fieldErrors['bkCargo.cargoDesc']" class="field-error-tip">
                                {{fieldErrors['bkCargo.cargoDesc']}}
                            </div>
                        </div>
                    </div>
                    <div style="width:32%;margin-top:2px">
                        <!--唛头-->
                        <div class="inputName ">
                            <div class="inputName-title">
                                <span class="redColor">{{$t('bookingSpace.cargo.shippingMark')}}</span>
                            </div>
                            <div style="position: relative; width: 100%;">
                                <el-input v-model="bkCargo.shippingMark" type="textarea" :rows="9"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                          :maxlength="9999"
                                          @input="formatUpperNoChinese('bkCargo','shippingMark',bkCargo.shippingMark,0,3150)"/>
                                <div class="textarea-word-limit">{{ (bkCargo.shippingMark || '').length }}/3150</div>
                            </div>
                            <div v-if="fieldErrors['bkCargo.shippingMark']" class="field-error-tip">
                                {{fieldErrors['bkCargo.shippingMark']}}
                            </div>
                        </div>
                    </div>
                    <div style="width:28%;margin-top:2px">
                        <!--件数-->
                        <div class="inputName margin-bottom3">
                            <div class="inputName-title">
                                <span>{{$t('bookingSpace.cargo.quantity')}}</span>
                            </div>
                            <el-input v-model.number="bkCargo.quantity"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      clearable/>
                        </div>
                        <!-- 毛重与净重并排 -->
                        <div class="flex" style="gap: 12px">
                            <!--毛重(KG)-->
                            <div class="inputName margin-bottom3">
                              <div class="inputName-title">
                                  <span>{{$t('bookingSpace.cargo.grossWeight')}}</span>
                              </div>
                              <el-input v-model="bkCargo.grossWeight"
                                        :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                        clearable
                                        @input="formatNumber('bkCargo','grossWeight',bkCargo.grossWeight,3)"/>
                            </div>
                            <!-- 净重(KG) -->
                            <div class="inputName margin-bottom3">
                              <div class="inputName-title">
                                <span>{{$t('bookingSpace.cargo.netWeight')}}</span>
                              </div>
                              <el-input v-model="bkCargo.netWeight"
                                        :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                        clearable
                                        @input="formatNumber('bkCargo','netWeight',bkCargo.netWeight,3)"/>
                            </div>
                        </div>
                        <!--尺寸-->
                        <div class="inputName margin-bottom3">
                            <div class="inputName-title">
                                <span class="redColor">{{$t('bookingSpace.cargo.cargoSize')}}</span>
                            </div>
                            <el-input v-model="bkCargo.cargoSize"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      @input="formatNumber('bkCargo','cargoSize',bkCargo.cargoSize,4)"/>
                        </div>
                        <el-row>
                            <el-col style="width: 40%">
                                <!--包装类型【只读状态】-->
                                <div class="inputName margin-bottom3">
                                    <el-col :span="7" style="width: 90%">
                                        <div class="inputName-title">
                                            <span class="redColor">{{$t('bookingSpace.cargo.packageType')}}</span>
                                        </div>
                                        <el-input v-model="bkCargo.packageType"
                                                  :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                                  readonly/>
                                    </el-col>
                                    <el-col :span="7" style="width: 10%">
                                        <!--包装类型弹框-->
                                        <el-popover ref="packageTypePopover" class="popover" width="600" trigger="click"
                                                    placement="right"
                                                    @hide="packageTypeShow=false">
                                            <div class="flex flex-space-between">
                                                <!--包装类型代码查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{$t('bookingSpace.cargo.packageTypeSearch')}}</span>
                                                    </div>
                                                    <el-input v-model="popover.packageType"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable
                                                              @input="formatUpperNoChinese('popover','packageType',popover.packageType)"/>
                                                </div>
                                                <!--包装类型弹框查询按钮-->
                                                <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                           @click="packageTypeSearch">
                                                    {{findButton}}
                                                </el-button>
                                            </div>
                                            <div class="flex flex-space-between">
                                                <!--包装类型名称查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{$t('bookingSpace.cargo.packageDescSearch')}}</span>
                                                    </div>
                                                    <el-input v-model="popover.packageDesc"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable
                                                              @input="formatUpperNoChinese('popover','packageDesc',popover.packageDesc)"/>
                                                </div>
                                                <!--包装类型弹框关闭按钮-->
                                                <el-button class="popoverInner" size="small" icon="el-icon-warning-outline"
                                                           @click="closePopoverView">
                                                    {{closeButton}}
                                                </el-button>
                                            </div>
                                            <!--包装类型数据表格-->
                                            <el-table :data="packageTypedata" class="packageTypePopover"
                                                      style="width:100%;margin-top:5px"
                                                      max-height="300" highlight-current-row
                                                      :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                                      :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                                      :empty-text="$t('common.noData')"
                                                      @row-dblclick="popConfirm"
                                                      @row-click="popRowClick">
                                                <el-table-column width="80" type="index" label="序号"></el-table-column>
                                                <el-table-column width="120" prop="codeValue" label="包装类型代码"></el-table-column>
                                                <el-table-column width="400" prop="displayValue" label="包装类型名称"></el-table-column>
                                            </el-table>
                                            <div class="flex flex-space-between">
                                                <div class="topMargin flex1">
                                                    {{`共${popover.popTotal}条`}}
                                                </div>
                                                <el-button class="popoverInner" type="primary"
                                                           @click="popConfirm">
                                                    {{confirmButton}}
                                                </el-button>
                                                <div class="pagination flex1">
                                                    <el-pagination max-height="600" small layout="sizes,pager"
                                                                   :page-size="popover.popPageSize"
                                                                   :page-sizes="[10, 20, 30, 40, 50]" :total="popover.popTotal"
                                                                   :pager-count="popover.popPageCount"
                                                                   :current-page="popover.popPageNum"
                                                                   @size-change="popHandleSizeChange"
                                                                   @current-change="popHandleCurrentChange"/>
                                                </div>
                                            </div>
                                            <img slot="reference" style="cursor:pointer" class="packageTypeButton"
                                                 src="../../assets/image/selectMore.png"/>
                                        </el-popover>
                                    </el-col>
                                </div>
                            </el-col>
                            <el-col style="width: 60%">
                                <!--包装描述-->
                                <div class="inputName margin-bottom3">
                                    <div class="inputName-title">
                                        <span class="redColor">{{$t('bookingSpace.cargo.packageDesc')}}</span>
                                    </div>
                                    <el-input v-model="bkCargo.packageDesc"
                                              :placeholder="getPlaceHolder($t('bookingSpace.cargo.packageDescPlaceholder'))"
                                              readonly/>
                                    <div v-if="fieldErrors['bkCargo.packageDesc']" class="field-error-tip">
                                        {{fieldErrors['bkCargo.packageDesc']}}
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="flex flex-space-around">
                    <!--特殊设置-->
                    <el-col style="width: 34%">
                        <div class="cardBody setting">
                            <ul class="flex">
                                <!--危险品信息-->
                                <el-popover placement="bottom" width="1000" trigger="click">
                                    <li class="flex flex-align" slot="reference">
                                        <input v-model="bookingHead.dgCheckFlag" type="checkbox" value=true
                                               @click="(($event) => {(validatePreInfo($event, 1))})"/>
                                        {{$t('bookingSpace.bkImos.bkImo')}}
                                    </li>
                                    <div class="position-right fullWidth">
                                        <!--危险品增加-->
                                        <img src="../../assets/image/icon/add1.svg" alt="" style="margin-right:8px"
                                             @click="addArray('bkImos')"
                                             v-show="bookingHead.dgCheckFlag">
                                        <!--危险品删除-->
                                        <img src="../../assets/image/icon/del1.svg" alt=""
                                             @click="removeArray('bkImos')"
                                             v-show="bookingHead.dgCheckFlag">
                                    </div>
                                    <!--危险品数据编辑表格-->
                                    <el-table class="table" :data="bkCargo.bkImos" style="width: 100%"
                                              :header-cell-style="{padding:'0px',height:'30px'}"
                                              :row-style="{height:'30px'}"
                                              :cell-style="{padding:'5px 0'}" :empty-text="$t('common.noData')">
                                        <el-table-column prop="classType" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.classType')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.classType"
                                                          @input="formatUpperNoChinese('bkImos','classType',scope.row.classType,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="unSeriseNo" label="UN No." min-width="100"
                                                         align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.unSeriseNo')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.unSeriseNo"
                                                          @input="formatUpperNoChinese('bkImos','unSeriseNo',scope.row.unSeriseNo,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="label" label="label" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.label')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.label"
                                                          @input="formatUpperNoChinese('bkImos','label',scope.row.label,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="packageDesc" label="包装种类" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.packageDesc')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.packageDesc"
                                                           placeholder=" "
                                                           clearable
                                                           @focus="dgPackageGroupFocus">
                                                    <el-option v-for="item in dgPackageGroupOptions"
                                                               :key="item.codeValue"
                                                               :label="item.displayValue"
                                                               :value="item.codeValue"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="packageCode" label="包装类型" min-width="120" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.packageCode')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.packageCode"
                                                          @input="formatUpperNoChinese('bkImos','packageCode',scope.row.packageCode,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="property" label="运输品名" min-width="120" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.property')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.property"
                                                          @input="formatUpperNoChinese('bkImos','property',scope.row.property,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="componentDesc" label="化学品名" min-width="120"
                                                         align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.componentDesc')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.componentDesc"
                                                          @input="formatUpperNoChinese('bkImos','componentDesc',scope.row.componentDesc,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="emergencySeq" label="应急措施编号" min-width="100"
                                                         align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.emergencySeq')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.emergencySeq"
                                                          @input="formatUpperNoChinese('bkImos','emergencySeq',scope.row.emergencySeq,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="emergencyTelNo" label="紧急联系" min-width="100"
                                                         align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.emergencyTelNo')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.emergencyTelNo"
                                                          @input="formatUpperNoChinese('bkImos','emergencyTelNo',scope.row.emergencyTelNo,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="quantity" label="件数" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.quantity')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.quantity"
                                                          oninput="value=value.replace(/[^0-9]/g,'')"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="grossWeight" label="毛重" min-width="115" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.grossWeight')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.grossWeight"
                                                          @input="formatNumber('bkImos','grossWeight',scope.row.grossWeight,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="netWeight" label="净重" min-width="115" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.netWeight')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.netWeight"
                                                          @input="formatNumber('bkImos','netWeight',scope.row.netWeight,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="flashPoint" label="闪点" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.flashPoint')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.flashPoint"
                                                          @input="formatNumber('bkImos','flashPoint',scope.row.flashPoint,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="rateBase" label="闪点单位" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.rateBase')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.rateBase"
                                                           placeholder=" "
                                                           clearable
                                                           @focus="rateBaseFocus">
                                                    <el-option v-for="item in rateBaseOptions"
                                                               :key="item.codeValue" :label="item.displayValue"
                                                               :value="item.codeValue"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="isPolutionFlag" label="是否海污" min-width="100"
                                                         align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.isPolutionFlag')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.isPolutionFlag"
                                                           placeholder=" "
                                                           clearable>
                                                    <el-option :key="true" :label="$t('common.yes')" :value="true"/>
                                                    <el-option :key="false" :label="$t('common.no')" :value="false"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-popover>
                                <!--冷箱信息-->
                                <el-popover placement="bottom" width="400" trigger="click">
                                    <li class="flex flex-align" slot="reference">
                                        <input v-model="bookingHead.rfCheckFlag" type="checkbox" value=true
                                               @click="((val) => {(validatePreInfo(val, 2))})"/>
                                        {{$t('bookingSpace.bkReefers.bkReefer')}}
                                    </li>
                                    <div class="position-right fullWidth">
                                        <!--冷箱增加按钮-->
                                        <img src="../../assets/image/icon/add1.svg" alt="" style="margin-right:8px"
                                             @click="addArray('bkReefers')"
                                             v-show="bookingHead.rfCheckFlag">
                                        <!--冷箱删除按钮-->
                                        <img src="../../assets/image/icon/del1.svg" alt=""
                                             @click="removeArray('bkReefers')"
                                             v-show="bookingHead.rfCheckFlag">
                                    </div>
                                    <!--冷箱数据编辑表格-->
                                    <el-table class="table" :data="bkCargo.bkReefers" style="width: 100%"
                                              :header-cell-style="{padding:'0px',height:'30px'}"
                                              :row-style="{height:'30px'}"
                                              :cell-style="{padding:'5px 0'}"
                                              :empty-text="$t('common.noData')">
                                        <el-table-column prop="rateBase" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkReefers.rateBase')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.rateBase"
                                                           placeholder=" "
                                                           clearable
                                                           @focus="rateBaseFocus">
                                                    <el-option v-for="item in rateBaseOptions"
                                                               :key="item.codeValue" :label="item.displayValue"
                                                               :value="item.codeValue"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="temperature" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkReefers.temperature')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.temperature"
                                                          @input="formatUpperNoChinese('bkReefers','temperature',scope.row.temperature,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="intakeNum" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkReefers.intakeNum')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.intakeNum"
                                                          @input="formatUpperNoChinese('bkReefers','intakeNum',scope.row.intakeNum,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-popover>
                                <!--SOC信息-->
                                <li class="flex flex-align">
                                    <input v-model="bookingHead.socCheckFlag" type="checkbox" value=true @change="handleSocCheckChange"/>
                                    {{$t('bookingSpace.bkSoc')}}
                                </li>
                                <!--特种箱信息-->
                                <el-popover placement="bottom" width="1000" trigger="click">
                                    <li class="flex flex-align" slot="reference">
                                        <input v-model="bookingHead.akCheckFlag" type="checkbox" value=true/>
                                        {{$t('bookingSpace.bkAks.bkAk')}}
                                    </li>
                                    <div class="position-right fullWidth">
                                        <!--特种箱增加按钮-->
                                        <img src="../../assets/image/icon/add1.svg" alt="" style="margin-right:8px"
                                             @click="addArray('bkAks')"
                                             v-show="bookingHead.akCheckFlag">
                                        <!--特种箱删除按钮-->
                                        <img src="../../assets/image/icon/del1.svg" alt=""
                                             @click="removeArray('bkAks')"
                                             v-show="bookingHead.akCheckFlag">
                                    </div>
                                    <!--特种箱数据编辑表格-->
                                    <el-table class="table" :data="bookingHead.bkAks" style="width: 100%"
                                              :header-cell-style="{padding:'0px',height:'30px'}"
                                              :row-style="{height:'30px'}"
                                              :cell-style="{padding:'5px 0'}"
                                              :empty-text="$t('common.noData')">
                                        <el-table-column prop="containerType" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkAks.containerType')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.containerType"
                                                           :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                                           clearable filterable default-first-option
                                                           @focus="containerTypeFocus">
                                                    <el-option v-for="item in containerTypeOptions"
                                                               :key="item.equipmentCode" :label="item.equipmentCode"
                                                               :value="item.equipmentCode">
                                                    </el-option>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="akLength" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkAks.akLength')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.akLength"
                                                          @input="formatNumber('bkAks','akLength',scope.row.akLength,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="akWidth" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkAks.akWidth')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.akWidth"
                                                          @input="formatNumber('bkAks','akWidth',scope.row.akWidth,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="akHigth" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkAks.akHigth')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.akHigth"
                                                          @input="formatNumber('bkAks','akHigth',scope.row.akHigth,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="akGrossWeight" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkAks.akGrossWeight')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.akGrossWeight"
                                                          @input="formatNumber('bkAks','akGrossWeight',scope.row.akGrossWeight,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-popover>

                            </ul>
                        </div>
                    </el-col>
                    <el-col style="width:38%;margin-top: 16px">
                        <!--【注释】*如果有多个HSCODE都需要填写。例如: 1231542,423441,23465-->
                        <div style="font-size: 14px;">
                            <span class="redColor">{{$t('bookingSpace.cargo.hscodeTips')}}</span>
                        </div>
                    </el-col>
                    <el-col style="width:28%;margin-top: 18px">

                        <!--HsCode-->
                        <div class="inputName margin-bottom3">
                            <div class="inputName-title">
                                <span class="redColor">HS CODE</span>
                            </div>
                            <el-input v-model="bookingHead.hsCode"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      :maxlength="9999"
                                      clearable
                                      @input="formatUpperNoChinese('bookingHead','hsCode',bookingHead.hsCode,0,30)">
                                <template slot="suffix">
                                    <span class="custom-word-limit">{{ (bookingHead.hsCode || '').length }}/30</span>
                                </template>
                            </el-input>
                            <div v-if="fieldErrors['bookingHead.hsCode']" class="field-error-tip">
                                {{fieldErrors['bookingHead.hsCode']}}
                            </div>
                        </div>
                    </el-col>
                </div>
            </div>
        </div>

        <!--订舱预配箱信息卡片【已订舱确认/锁定/解锁，不可编辑】-->
        <div class="cardBox">
            <div class="cardTitle flex flex-space-between">
                <div>
                    <img src="../../assets/image/icon/order10.svg" alt="">
                    <span>{{$t('bookingSpace.preContainer.preContainerInfo')}}</span>
                </div>
                <el-button icon="el-icon-plus" class="blue-button" size="mini"
                           @click="addBkPreContainer"
                           v-if="false">
                    {{addButton}}
                </el-button>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around" v-for="(i,j) in bkPreContainers" :key="j">
                    <!--箱型-->
                    <div class="inputName margin-bottom">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.preContainer.containerType')}}</span>
                        </div>
                        <el-select v-model="i.containerType"
                                   clearable filterable default-first-option disabled
                                   @focus="containerTypeFocus">
                            <el-option v-for="item in containerTypeOptions"
                                       :key="item.equipmentCode" :label="item.equipmentCode"
                                       :value="item.equipmentCode">
                                <span style="float: left">{{item.equipmentCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.containerDesc}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--件数-->
                    <div class="inputName margin-bottom">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.preContainer.quantity')}}</span>
                        </div>
                        <el-input v-model="i.quantity"
                                  clearable readonly
                                  oninput="value=value.replace(/[^0-9]/g,'')"/>
                    </div>
                    <!--货类-->
                    <div class="inputName margin-bottom">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.preContainer.cargoTypeCode')}}</span>
                        </div>
                        <el-select v-model="i.cargoTypeCode"
                                   clearable filterable default-first-option disabled
                                   @focus="cargoTypeFocus"
                                   @input="((val) => {validateCargoTypeCode(val,j)})">
                            <el-option v-for="item in cargoTypeOptions"
                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">
                            </el-option>
                        </el-select>
                    </div>
                    <!--订舱预配箱-删除按钮-->
                    <el-button icon="el-icon-delete" type="danger" size="mini" disabled
                               @click="removeBkPreContainer(i,j)">
                        {{deleteButton}}
                    </el-button>
                </div>
            </div>
        </div>

        <!--集装箱信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-space-between">
                <div>
                    <img src="../../assets/image/icon/order12.svg" alt="">
                    <span>{{$t("bookingSpace.container.containerInfo")}}</span>
                </div>
                <div class="flex flex-space-between">
<!--                    <download-excel-->
<!--                            class = "export-excel-wrapper"-->
<!--                            :data = "json_data"-->
<!--                            :fields = "json_fields"-->
<!--                            name = "containerImportTemplate.xls">-->
<!--                        <el-button icon="el-icon-download" type="text" size="mini">{{ExcelDownloadButton}}</el-button>-->
<!--                    </download-excel>-->
<!--                    <el-button icon="el-icon-download" type="text" size="mini" @click="excelTemplateDownload">{{ExcelDownloadButton}}</el-button>-->
                    <el-link type="primary" style="font-size: 12px;margin-right: 10px" icon="el-icon-download" :underline="false"
                             href="/static/containerImportTemplate.xls" download="CONTAINER_IMPORT_TEMPLATE.xls">{{ExcelDownloadButton}}</el-link>
<!--                    <el-upload-->
<!--                            class="upload-demo"-->
<!--                            ref="upload"-->
<!--                            action=""-->
<!--                            :auto-upload="false"-->
<!--                            :file-list="fileList"-->
<!--                            :on-change="handleChange"-->
<!--                            :show-file-list="false" style="margin-right:10px;float:right;position: relative">-->
<!--                        <el-button icon="el-icon-upload" class="red-button" size="mini">{{ExceluploadButton}}</el-button>-->
<!--                    </el-upload>-->
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            accept=".xls,.xlsx"
                            :auto-upload="true"
                            :file-list="fileList"
                            :http-request="handleUpload"
                            :show-file-list="false" style="margin-right:10px;float:right;position: relative">
                        <el-button icon="el-icon-upload" class="red-button" size="mini">{{ExceluploadButton}}</el-button>
                    </el-upload>
                    <el-button icon="el-icon-edit" class="blue-button" size="mini"
                               @click="editContainerTableData">
                        {{editButton}}
                    </el-button>
                    <el-button icon="el-icon-plus" class="blue-button" size="mini"
                               @click="addContainerTableData">
                        {{addButton}}
                    </el-button>
                </div>
            </div>
            <div class="cardBody">
                <el-table max-height="600" :data="bkContainers" style="width:100%;"
                          :header-cell-style="{background:'#E9E9E9',height:'36px',padding:'0px'}"
                          :row-style="{height:'40px'}"
                          :cell-style="{padding:'0px'}"
                          :empty-text="$t('common.noData')">
                    <el-table-column min-width="60" type="index" :label="$t('booking.popover.no')" align="center"></el-table-column>
                    <!--箱号-->
                    <el-table-column min-width="130" show-overflow-tooltip prop="containerNo"
                                     :label="$t('bookingSpace.container.containerNo')" align="center">
                    </el-table-column>
                    <!--箱型-->
                    <el-table-column min-width="90" show-overflow-tooltip prop="containerType"
                                     :label="$t('bookingSpace.container.containerType')" align="center">
                    </el-table-column>
                    <!--铅封号1-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="sealNo1"
                                     :label="$t('bookingSpace.container.sealNo1')" align="center">
                    </el-table-column>
                    <!--铅封号2-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="sealNo2"
                                     :label="$t('bookingSpace.container.sealNo2')" align="center"></el-table-column>
                    <!--铅封号3-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="sealNo3"
                                     :label="$t('bookingSpace.container.sealNo3')" align="center"></el-table-column>
                    <!--铅封号4-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="sealNo4"
                                     :label="$t('bookingSpace.container.sealNo4')" align="center"></el-table-column>
                    <!--件数-->
                    <el-table-column min-width="90" show-overflow-tooltip prop="quantity"
                                     :label="$t('bookingSpace.container.quantity')" align="center"></el-table-column>
                    <!--毛重-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="weight"
                                     :label="$t('bookingSpace.container.weight')" align="center"></el-table-column>
                    <!--箱皮重-->
                    <el-table-column min-width="110" show-overflow-tooltip prop="containerWeight"
                                     :label="$t('bookingSpace.container.containerWeight')"
                                     align="center"></el-table-column>
                    <!--体积-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="cntrSize"
                                     :label="$t('bookingSpace.container.cntrSize')" align="center"></el-table-column>
                    <!--货类-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="cargoTypeCode"
                                     :label="$t('bookingSpace.container.cargoTypeCode')" align="center">
                        <template slot-scope="scope">
                            <span>{{getCargoTypeName(scope.row.cargoTypeCode)}}</span>
                        </template>
                    </el-table-column>
                    <!--箱主-->
                    <el-table-column min-width="130" show-overflow-tooltip prop="containerManager"
                                     :label="$t('bookingSpace.container.containerManager')"
                                     align="center"></el-table-column>
                    <!--货名（white-space:pre-line：导入的货名含换行符时按换行展示，避免用户误以为导入时换行被自动去掉）-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="cargoDesc"
                                     :label="$t('bookingSpace.container.cargoDesc')" align="center">
                        <template slot-scope="scope">
                            <div class="cargo-desc-preline">{{ scope.row.cargoDesc }}</div>
                        </template>
                    </el-table-column>
                    <!--HS CODE-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="hsCode"
                                     :label="$t('bookingSpace.container.hsCode')" align="center"></el-table-column>
                    <!--IMDG CLASS-->
                    <el-table-column min-width="110" show-overflow-tooltip prop="classType"
                                     :label="$t('bookingSpace.container.classType')" align="center"></el-table-column>
                    <!--UN No.-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="unSerialNo"
                                     :label="$t('bookingSpace.container.unSerialNo')" align="center"></el-table-column>
                    <!--REEFER TEMP-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="reeferTemp"
                                     :label="$t('bookingSpace.container.reeferTemp')" align="center"></el-table-column>
                    <!--操作-->
                    <el-table-column min-width="100" show-overflow-tooltip
                                     :label="$t('bookingSpace.container.operation')" align="center">
                        <template slot-scope="scope">
                            <img src="../../assets/image/icon/del1.svg" alt=""
                                 @click="removeContainerTableData(scope.row,scope.$index)">
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!--其他信息卡片-->
        <div class="flex fullWidth">
            <div class="cardBox lastCardBox2" style=" width:100%">
                <div class="cardTitle flex flex-align">
                    <img src="../../assets/image/icon/order9.svg" alt="">
                    <span>{{$t('bookingSpace.other.otherInfo')}}</span>
                </div>
                <div class="cardBody">
                    <div class="flex flex-space-around">
                        <!--SI备注-->
                        <div class="inputName">
                            <div class="inputName-title">
                                <span>{{$t('bookingSpace.other.siRemark')}}</span>
                            </div>
                            <el-input v-model="bkExtend.siRemark"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      clearable
                                      @input="formatUpper('bkExtend','siRemark',bkExtend.siRemark)"/>
                            <div v-if="fieldErrors['bkExtend.siRemark']" class="field-error-tip">
                                {{fieldErrors['bkExtend.siRemark']}}
                            </div>
                        </div>
                        <!--提单拒绝【禁用状态，不可编辑，仅在提单拒绝时显示】-->
                        <div class="inputName" v-show="bookingHead.blStatus == 2">
                            <div class="inputName-title">
                                <span>{{$t('bookingSpace.other.blReject')}}</span>
                            </div>
                            <el-input v-model="siRejectReason"
                                      readonly/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--底部按钮组-->
        <div class="footer-group">
            <!--保存草稿按钮-->
            <el-button class="save-yellow-button" type="warning" :disabled="!getBlDraftFlag"
                       @click="returnSave">
                {{saveButton}}
            </el-button>
            <!--保存并发送船公司按钮-->
            <el-button class="save-blue-button"
                       @click="returnSend">
                {{saveAndSendButton}}
            </el-button>
            <!--返回按钮-->
            <el-button class="return-button" type="info"
                       @click="returnPage">
                {{returnButton}}
            </el-button>
        </div>

        <!--新增集装箱弹出框-->
        <el-dialog :visible.sync="addContainerDataShow" width="98%" top="10%"
                   :before-close="((val) => {handleClose(val,0)})">
            <div slot="title" class="flex flex-align">
                <img src="../../assets/image/icon/order-ico5.svg" alt="">
                {{$t("bookingSpace.container.containerInfo")}}
            </div>
            <el-table :data="editBkContainers" style="width: 100%" class="table"
                      :header-cell-style="{padding:'0px',height:'30px'}"
                      :row-style="{height:'30px'}"
                      :cell-style="{padding:'5px 0'}"
                      :empty-text="$t('common.noData')">
                <el-table-column min-width="60" type="index" :label="$t('booking.popover.no')" align="center"></el-table-column>
                <!--集装箱弹出框-箱号-->
                <el-table-column min-width="140" align="center">
                    <template slot="header">
                        <span class="redColor">*{{$t("bookingSpace.container.containerNo")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.containerNo"
                                  maxlength="11"
                                  @input="formatUpper('editBkContainers','containerNo',scope.row.containerNo,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-箱型-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span class="redColor">*{{$t("bookingSpace.container.containerType")}}</span>
                        <span></span>
                    </template>
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.containerType"
                                   placeholder=" "
                                   clearable filterable default-first-option
                                   @focus="containerTypeFocus"
                                   @change="setContainerWeight(scope.$index,scope.row.containerType)">
                            <el-option v-for="item in containerTypeOptions"
                                       :key="item.equipmentCode" :label="item.equipmentCode"
                                       :value="item.equipmentCode"/>
                        </el-select>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-铅封号1-->
                <el-table-column min-width="110" align="center">
                    <template slot="header">
                        <span class="redColor">*{{$t("bookingSpace.container.sealNo1")}}</span>
                        <span></span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sealNo1"
                                  @input="formatUpper('editBkContainers','sealNo1',scope.row.sealNo1,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-铅封号2-->
                <el-table-column min-width="110" align="center">
                    <template slot="header">
                        <span class="redColor">*</span>
                        <span>{{$t("bookingSpace.container.sealNo2")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sealNo2"
                                  @input="formatUpper('editBkContainers','sealNo2',scope.row.sealNo2,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-铅封号3-->
                <el-table-column min-width="110" align="center">
                    <template slot="header">
                        <span class="redColor">*</span>
                        <span>{{$t("bookingSpace.container.sealNo3")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sealNo3"
                                  @input="formatUpper('editBkContainers','sealNo3',scope.row.sealNo3,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-铅封号4-->
                <el-table-column min-width="110" align="center">
                    <template slot="header">
                        <span class="redColor">*</span>
                        <span>{{$t("bookingSpace.container.sealNo4")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sealNo4"
                                  @input="formatUpper('editBkContainers','sealNo4',scope.row.sealNo4,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-件数-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span class="redColor">*</span>
                        <span>{{$t("bookingSpace.container.quantity")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.quantity"
                                  oninput="value=value.replace(/[^0-9]/g,'')"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-毛重-->
                <el-table-column min-width="90" align="center">
                    <template slot="header">
                        <span class="redColor">*</span>
                        <span>{{$t("bookingSpace.container.weight")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.weight"
                                  @input="formatNumber('editBkContainers','weight',scope.row.weight,3,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-箱皮重-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span class="redColor">*</span>
                        <span>{{$t("bookingSpace.container.containerWeight")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.containerWeight"
                                  @input="formatNumber('editBkContainers','containerWeight',scope.row.containerWeight,3,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-体积-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span class="redColor">*</span>
                        <span>{{$t("bookingSpace.container.cntrSize")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.cntrSize"
                                  @input="formatNumber('editBkContainers','cntrSize',scope.row.cntrSize,4,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-货类-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span class="redColor">*{{$t("bookingSpace.container.cargoTypeCode")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.cargoTypeCode"
                                   placeholder=" "
                                   clearable filterable default-first-option
                                   @focus="cargoTypeFocus">
                            <el-option v-for="item in cargoTypeOptions"
                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue"/>
                        </el-select>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-箱主-->
                <el-table-column min-width="90" align="center">
                    <template slot="header">
                        <span class="redColor">*</span>
                        <span>{{$t("bookingSpace.container.containerManager")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.containerManager" disabled>
                            <el-option key="SOC" label="SOC" value="SOC"/>
                            <el-option key="ZGL" label="ZGL" value="ZGL"/>
                        </el-select>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-货名（textarea固定单行输入框高度，换行内容在框内滚动展示，避免撑高表格行破坏布局）-->
                <el-table-column min-width="200" align="center">
                    <template slot="header">
                        <span>{{$t("bookingSpace.container.cargoDesc")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.cargoDesc" type="textarea" :rows="1" resize="none"
                                  class="cargo-desc-textarea"
                                  @input="formatUpperNoChinese('editBkContainers','cargoDesc',scope.row.cargoDesc,scope.$index,1000)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-HS CODE-->
                <el-table-column min-width="150" align="center">
                    <template slot="header">
                        <span>{{$t("bookingSpace.container.hsCode")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.hsCode"
                                  @input="formatUpperNoChinese('editBkContainers','hsCode',scope.row.hsCode,scope.$index,20)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-IMDG CLASS-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span>{{$t("bookingSpace.container.classType")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.classType"
                                  @input="formatUpperNoChinese('editBkContainers','classType',scope.row.classType,scope.$index,20)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-UN No.-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span>{{$t("bookingSpace.container.unSerialNo")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.unSerialNo"
                                  @input="formatUpperNoChinese('editBkContainers','unSerialNo',scope.row.unSerialNo,scope.$index,50)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-REEFER TEMP-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span>{{$t("bookingSpace.container.reeferTemp")}}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.reeferTemp"
                                  @input="formatUpperNoChinese('editBkContainers','reeferTemp',scope.row.reeferTemp,scope.$index,10)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-删除按钮-->
                <el-table-column min-width="95" :label="$t('bookingSpace.container.operation')" align="center">
                    <template slot-scope="scope">
                        <img src="../../assets/image/icon/del1.svg"
                             @click="removeBkContainer(scope.row,scope.$index)">
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
        <!--集装箱编辑弹框-增加按钮-->
        <el-button class="blue-button-text"
                   @click="addBkContainer">
            {{addButton2}}
        </el-button>
        <!--集装箱编辑弹框-确定按钮-->
        <el-button class="blue-button"
                   @click="((val) => {handleClose(val,1)})">
            {{okButton2}}
        </el-button>
        <!--集装箱编辑弹框-取消按钮-->
        <el-button class="blue-button"
                   @click="handleCancel">
            {{cancelButton}}
        </el-button>
      </span>
        </el-dialog>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>
<script>
    import {formatUpperNoChinese as formatUpperNoChineseOriginal, formatUpper as formatUpperOriginal} from "../../utils/formatInput";

    export default {
        name: 'lading-details',
        computed: {
            //控制【保存草稿】按钮可用状态
            getBlDraftFlag() {
                return this.bookingHead.blStatus == 4           //草稿
                    // || this.bookingHead.blStatus == 2   //拒绝
                    || this.bookingHead.blStatus == 3   //空
                    || this.bookingHead.blStatus == null;
            },
            /************************************ 页面按钮国际化信息 ***********************************/
            //保存草稿按钮
            saveButton() {
                return this.$t("common.saveButton");
            },
            //保存并发送船公司按钮
            saveAndSendButton() {
                return this.$t("common.saveAndSendButton");
            },
            //返回按钮
            returnButton() {
                return this.$t("common.returnButton");
            },
            //编辑按钮
            editButton() {
                return this.$t("common.editButton");
            },
            //增加按钮
            addButton() {
                return this.$t("common.addButton");
            },
            //EXCEL导入模板下载按钮
            ExcelDownloadButton() {
                return this.$t("common.ExcelDownloadButton");
            },
            //EXCEL导入按钮
            ExceluploadButton() {
                return this.$t("common.ExceluploadButton");
            },
            //集装箱新增按钮
            addButton2() {
                return this.$t("common.addButton2");
            },
            //删除按钮
            deleteButton() {
                return this.$t("common.deleteButton");
            },
            //确定按钮
            okButton2() {
                return this.$t("common.okButton2");
            },
            //取消按钮
            cancelButton() {
                return this.$t("common.cancelButton");
            },
            //弹框搜索按钮
            findButton() {
                return this.$t("common.findButton");
            },
            //弹框关闭按钮
            closeButton() {
                return this.$t("common.closeButton");
            },
            //弹框确认按钮
            confirmButton() {
                return this.$t("common.confirmButton");
            },
            siRejectReason(){
                if(this.bookingHead.blStatus==2){
                    return this.bkExtend.siRejectReason;
                }else{
                    return "";
                }
            },

            /**
             * 根据当前登录主体获取carrier值
             * @returns {string} carrier值 (ZGL 或 ZSS)
             */
            getCarrierByEntity() {
                const entityType = this.$apiUtils.getCurrentEntity();
                return entityType === "2" ? "ZSS" : "ZGL";
            },
            isSGP() {
              // 判断是否为“新加坡”主体
              const entityType = this.$apiUtils.getCurrentEntity();
              return entityType === "2";
            }
        },
        data() {
            return {
                fieldErrors: {},            //字段错误信息对象，用于存储各字段的校验错误提示
                isSaveClick: false,         //控制保存草稿按钮是否重复点击
                isSendClick: false,         //控制保存并发送船公司按钮是否重复点击
                isPopSearchClick: false,
                packageTypeShow: false,
                portOptions: [],
                carrierOptions: [],         //承运人下拉选项
                bookingStatusOptions: [],
                blStatusOptions: [
                    {codeValue: 0, displayValueCn: "等待", displayValue: "Waiting"},
                    {codeValue: 1, displayValueCn: "确认", displayValue: "Confirm"},
                    {codeValue: 2, displayValueCn: "拒绝", displayValue: "Refuse"},
                    {codeValue: 3, displayValueCn: "空", displayValue: "Blank"},
                    {codeValue: 4, displayValueCn: "草稿", displayValue: "Draft"},
                ],
                containerManagerOptions: [
                    {codeValue: "ZGL", displayValueCn: "ZGL", displayValue: "ZGL"},
                    {codeValue: "SOC", displayValueCn: "SOC", displayValue: "SOC"},
                ],
                paidTypeOptions: [],
                bookingTypeOptions: [],
                blTypeOptions: [],
                deliveryMethodOptions: [//单证类型
                    {codeValue: 1, displayValueCn: "正本提单", displayValue: "OBL"},
                    {codeValue: 2, displayValueCn: "海运单", displayValue: "SW"},
                    {codeValue: 3, displayValueCn: "电放提单", displayValue: "TLX"}
                ],
                transportationTermsOptions: [],
                cargoTypeOptions: [],
                containerTypeOptions: [],
                rateBaseOptions: [],
                dgPackageGroupOptions: [],
                cargoDescAndHscodeRequiredRouteList: [],// 箱信息货名及HSCODE必填航线信息
                customerNos: ["1", "2", "3", "4"],
                packageTypedata: [],            //货物包装类型数据
                popover: {
                    packageType: "",
                    packageDesc: "",
                    popTableSelection: [],
                    popTotal: 0,
                    popPageCount: 5,
                    popPageNum: 1,
                    popPageSize: 50,
                },
                bookingHead: {
                    //舱单ID
                    bookingHeadId: "",
                    //船期ID
                    voyagePlanId: "",
                    //【订舱信息】
                    bkNo: "",
                    blNo: "",
                    blStatus: "",
                    bookingType: "",
                    transportationTerms: "",
                    paidType: "",
                    agreementNo: "",
                    sales: "",
                    //【提单信息】
                    // blType: null,
                    deliveryDocumentMethod: null,
                    deliveryDocumentPlace: "",
                    deliveryDocumentQuantity: "",
                    paidPalce: "",
                    //【地点信息】
                    por: "",
                    pol: "",
                    pod: "",
                    del: "",
                    transitPort: "",            //接舱卸货港
                    //【船舶信息】
                    vesselCode: "",
                    vesselName: "",
                    vesselNameCn: "",
                    voyageNo: "",
                    voyageLeg: "",
                    saillingDate: "",
                    serviceLineCode: "",
                    //【特殊设置】
                    dgCheckFlag: false,
                    rfCheckFlag: false,
                    socCheckFlag: false,
                    akCheckFlag: false,
                    //【其他信息】
                    remark: "",
                    rejectReason: "",
                    //【特种箱信息】
                    bkAks: [],
                    hsCode: "",
                    tsFlag: false,
                    transportType: 0    //运输类型（默认为"本港"）
                },
                //【舱单扩展信息】
                bkExtend: {
                    siRemark: "",
                    bkExtendId: "",
                    applicantUnit: "",
                    porName: "",
                    polName: "",
                    podName: "",
                    delName: "",
                    siRejectReason:""
                },
                //【货物信息】
                bkCargo: {
                    bkCargoId: "",
                    quantity: "",
                    grossWeight: "",
                    cargoSize: "",
                    cargoDesc: "",
                    shippingMark: "",
                    packageType: "",
                    packageDesc: "",
                    //【危险品信息】
                    bkImos: [],
                    //【冷箱信息】
                    bkReefers: []
                },
                /*【发货人信息】*/
                shipper: {
                    bkCustomerId: "",
                    customerType: 0,        //客户类型0：发货人
                    customerNameCatalogId: "",
                    customerNamePrintFlag: true,
                    customerName: "",
                    companyName: "",
                    CompanyNamePrintFlag:false,
                    CompanyNameCatalogId:"",
                    address:"",
                    addressPrintFlag:false,
                    addressCatalogId:"",
                    city:"",
                    cityPrintFlag:false,
                    cityCatalogId:"",
                    provinceCode:"",
                    provinceCodePrintFlag:false,
                    provinceCodeCatalogId:"",
                    provinceName:"",
                    provinceNamePrintFlag:false,
                    provinceNameCatalogId:"",
                    postCode:"",
                    postCodePrintFlag:false,
                    postCodeCatalogId:"",
                    countryCodeCatalogId: "",
                    countryCodePrintFlag: false,
                    countryCode: "",
                    telCatalogId: "",
                    telPrintFlag: false,
                    tel: "",
                    emailCatalogId: "",
                    emailPrintFlag: false,
                    email: "",
                    enterpriseCodeCatalogId: "",
                    enterpriseCodePrintFlag: false,
                    enterpriseCode: "",
                    printFlag: false,
                    otherCatalogs: []
                },
                /*【收货人信息】*/
                consignee: {
                    bkCustomerId: "",
                    customerType: 1,        //客户类型1：收货人
                    companyName: "",
                    customerNameCatalogId: "",
                    customerNamePrintFlag: true,
                    customerName: "",
                    address:"",
                    addressPrintFlag:false,
                    addressCatalogId:"",
                    city:"",
                    cityPrintFlag:false,
                    cityCatalogId:"",
                    provinceCode:"",
                    provinceCodePrintFlag:false,
                    provinceCodeCatalogId:"",
                    provinceName:"",
                    provinceNamePrintFlag:false,
                    provinceNameCatalogId:"",
                    postCode:"",
                    postCodePrintFlag:false,
                    postCodeCatalogId:"",
                    countryCodeCatalogId: "",
                    countryCodePrintFlag: false,
                    countryCode: "",
                    telCatalogId: "",
                    telPrintFlag: false,
                    tel: "",
                    emailCatalogId: "",
                    emailPrintFlag: false,
                    email: "",
                    enterpriseCodeCatalogId: "",
                    enterpriseCodePrintFlag: false,
                    enterpriseCode: "",
                    printFlag: false,
                    otherCatalogs: []
                },
                /*【通知人1信息】*/
                notifier1: {
                    bkCustomerId: "",
                    customerType: 2,        //客户类型2：通知人1
                    companyName: "",
                    customerNameCatalogId: "",
                    customerNamePrintFlag: true,
                    customerName: "",
                    address:"",
                    addressPrintFlag:false,
                    addressCatalogId:"",
                    city:"",
                    cityPrintFlag:false,
                    cityCatalogId:"",
                    provinceCode:"",
                    provinceCodePrintFlag:false,
                    provinceCodeCatalogId:"",
                    provinceName:"",
                    provinceNamePrintFlag:false,
                    provinceNameCatalogId:"",
                    postCode:"",
                    postCodePrintFlag:false,
                    postCodeCatalogId:"",
                    countryCodeCatalogId: "",
                    countryCodePrintFlag: false,
                    countryCode: "",
                    telCatalogId: "",
                    telPrintFlag: false,
                    tel: "",
                    emailCatalogId: "",
                    emailPrintFlag: false,
                    email: "",
                    enterpriseCodeCatalogId: "",
                    enterpriseCodePrintFlag: false,
                    enterpriseCode: "",
                    printFlag: false,
                    otherCatalogs: []
                },
                /*【通知人2信息】*/
                notifier2: {
                    bkCustomerId: "",
                    customerType: 3,        //客户类型3：通知人2
                    companyName: "",
                    customerNameCatalogId: "",
                    customerNamePrintFlag: true,
                    customerName: "",
                    address:"",
                    addressPrintFlag:false,
                    addressCatalogId:"",
                    city:"",
                    cityPrintFlag:false,
                    cityCatalogId:"",
                    provinceCode:"",
                    provinceCodePrintFlag:false,
                    provinceCodeCatalogId:"",
                    provinceName:"",
                    provinceNamePrintFlag:false,
                    provinceNameCatalogId:"",
                    postCode:"",
                    postCodePrintFlag:false,
                    postCodeCatalogId:"",
                    countryCodeCatalogId: "",
                    countryCodePrintFlag: false,
                    countryCode: "",
                    telCatalogId: "",
                    telPrintFlag: false,
                    tel: "",
                    emailCatalogId: "",
                    emailPrintFlag: false,
                    email: "",
                    enterpriseCodeCatalogId: "",
                    enterpriseCodePrintFlag: false,
                    enterpriseCode: "",
                    printFlag: false,
                    otherCatalogs: []
                },
                //【运输信息】
                bkRouting1: {
                    bkRoutingId: "",
                    tripNumber: 0,
                    lineType: 1,//0:支线 1:干线
                    vesselCode: "",
                    voyageNo: "",
                    voyageLeg: "",
                    saillingDate: "",
                    carrier: "",
                    serviceLineCode: "",
                    voyagePlanId: "",
                    portFrom: "",
                    portTo: "",
                    inTransportType: 0,
                    outTransportType: 0,
                    isNoticedFlag: false,
                    bookingStatus: null,
                    msn: ""
                },
                bkRoutingPre: {
                    bkRoutingId: "",
                    tripNumber: 0,
                    lineType: 0,//0:支线 1:干线
                    portFrom: "",
                    portTo: "",
                    serviceLineCode: "",
                    vesselCode: "",
                    vesselName: "",
                    voyageNo: "",
                    voyageLeg: "",
                    saillingDate: "",
                    carrier: "",
                    isNoticedFlag: false,
                    bookingStatus: null,
                    outTransportType: "",//出口运输类型
                    inTransportType: ""//进口运输类型
                },
                bkRoutingNext: {
                    bkRoutingId: "",
                    tripNumber: 0,
                    lineType: 0,//0:支线 1:干线
                    portFrom: "",
                    portTo: "",
                    vesselCode: "",
                    vesselName: "",
                    voyageNo: "",
                    voyageLeg: "",
                    saillingDate: "",
                    carrier: "",
                    isNoticedFlag: false,
                    bookingStatus: null,
                    outTransportType: "",//出口运输类型
                    inTransportType: ""//进口运输类型
                },
                bkRoutingTransit: {},
                //【订舱预配箱信息】
                bkPreContainers: [],
                //【集装箱信息】
                bkContainers: [],
                editBkContainers: [],
                addContainerDataShow: false,
                deleteBkImos: [],           //待删除的危险品记录
                deleteBkReefers: [],        //待删除的冷箱记录
                deleteBkAks: [],            //待删除的特种箱记录
                deleteBkPreContainers: [],  //待删除的订舱预配箱记录
                deleteBkContainers: [],      //待删除的集装箱记录
                editDeleteBkContainers: [],      //待删除的集装箱记录
                json_fields: {
                    "序号<br/>No.": "no",
                    "箱号<br/>Container No": "containerNo",
                    "箱型尺寸<br/>Size/Type": "containerType",
                    "箱管理人<br/>CNTR Manager": "containerManager",
                    "封签号1<br/>Seal No1": "sealNo1",
                    "封签号2<br/>Seal No2": "sealNo2",
                    "封签号3<br/>Seal No3": "sealNo3",
                    "封签号4<br/>Seal No4": "sealNo4",
                    "件数<br/>Quantity": "quantity",
                    "毛重(KGS)<br/>Gross Weight(KGS)": "weight",
                    "净重(KGS)<br/>Net Weight(KGS)": "netWeight",
                    "箱皮重(KGS)<br/>Tare Weight(KGS)": "netWeight",
                    "尺寸(CBM)<br/>Size(CBM)": "cntrSize",
                    "货物类型<br/>Cargo Type": "cargoTypeCode",
                    "挂衣箱型<br/>Hg Type": "hgType",
                    "高代平(Yes/No)<br/>HTGP": "hqToGpFlag",
                    "超重(Yes/No)<br/>OverWeight Flag": "overWeightFlag",
                    "超重重量<br/>Over Weight": "overWeight",
                    "冻危(Yes/No)<br/>Rf Dg Flag": "rfDgFlag",
                },
                json_data: [{
                    no: "",
                    containerNo: "",
                    containerType: "",
                    containerManager: "",
                    sealNo1: "",
                    quantity: "",
                    weight: "",
                    netWeight: "",
                    containerWeight: "",
                    cntrSize: "",
                    cargoTypeCode: "",
                    hgType: "",
                    hqToGpFlag: "",
                    overWeightFlag: "",
                    overWeight: "",
                    rfDgFlag: ""
                }],
                json_meta: [
                    [
                        {
                            "key": "charset",
                            "value": "utf-8"
                        }
                    ]
                ],
                fileList:[],
                file:"",
                initialCustomerName: ""
            }
        },
        methods: {
            /**
             * 包装 formatUpperNoChinese 方法，确保 this 上下文正确
             */
            formatUpperNoChinese(parent, prop, value, index, maxLength) {
                // 确保 fieldErrors 对象存在
                if (!this.fieldErrors) {
                    this.$set(this, 'fieldErrors', {});
                }
                // 调用原始的格式化函数，this 会指向当前 Vue 实例
                return formatUpperNoChineseOriginal.call(this, parent, prop, value, index, maxLength);
            },
            /**
             * 包装 formatUpper 方法，确保 this 上下文正确
             */
            formatUpper(parent, prop, value, index) {
                // 确保 fieldErrors 对象存在
                if (!this.fieldErrors) {
                    this.$set(this, 'fieldErrors', {});
                }
                // 调用原始的格式化函数，this 会指向当前 Vue 实例
                return formatUpperOriginal.call(this, parent, prop, value, index);
            },
            /**
             * 获取字段错误信息
             * @param {string} parent - 父级属性
             * @param {string} prop - 当前属性
             * @param {number} index - 可选，数组索引
             * @returns {string} 错误信息，如果没有错误则返回空字符串
             */
            getFieldError(parent, prop, index) {
                const errorKey = index !== undefined ? `${parent}.${prop}.${index}` : `${parent}.${prop}`;
                return this.fieldErrors && this.fieldErrors[errorKey] ? this.fieldErrors[errorKey] : '';
            },

            /**
             * 业务员字段输入处理：仅限制长度为 20，允许中文和任意字符
             * @param {string} val - 当前输入的值
             */
            handleSalesInput(val) {
              // 1. 处理空值情况
              if (!val) {
                this.bookingHead.sales = '';
                // 清空可能的错误提示
                if (this.fieldErrors['bookingHead.sales']) {
                  this.$set(this.fieldErrors, 'bookingHead.sales', '');
                }
                return;
              }

              // 2. 长度校验与截断 (数据库 varchar(20))
              const maxLength = 20;
              if (val.length > maxLength) {
                // 截断字符串
                this.bookingHead.sales = val.substring(0, maxLength);


                // 弹出提示，可以取消下面注释：
                this.$set(this.fieldErrors, 'bookingHead.sales',this.$t('common.overLength',{maxLength:maxLength}));

                // // 确保 fieldErrors 中没有残留错误，因为我们已经强制截断了
                // if (this.fieldErrors['bookingHead.sales']) {
                //   this.$set(this.fieldErrors, 'bookingHead.sales', '');
                // }
              } else {
                // 3. 未超长，正常赋值
                this.bookingHead.sales = val;

                // 如果之前有错误（比如提交后报错），当用户修改时清空错误
                if (this.fieldErrors['bookingHead.sales']) {
                  this.$set(this.fieldErrors, 'bookingHead.sales', '');
                }
              }
            },

            /**
             * 箱号导入
             *  handleChange 会自动执行2次,一次是选择文件时,一次是:不管失败或者成功都会在执行一次,
             *  如果执行2次,明显是不可以的;需把其中的一次给过滤掉;
             *  发现第1次执行时,就已经将xlsx文件中的数据已经拿到了,第2次就是失败的 ,此时vfileList 的长度是0
             *  所以做一个判断: 将以下所有的代码 放在if(fileList.length !==0){ 所有的代码放入这里} 就可以避免第二次重复执行逻辑代码,只让它执行一下 handleChange 事件
             */
            handleChange(file,fileList) {
                if(fileList.length !==0){
                    this.fileList = [fileList[fileList.length - 1]]; // 只能上传一个Excel，重复上传会覆盖之前的
                    this.file = file.raw;
                    try{
                        //调用执行
                        this.readExcelToJson(file.raw).then((res) => {
                            let isSucceed = true;
                            if(res && res.length > 0){
                                let importBkContainers = [];//清空导入箱信息集合
                                res.forEach((item)=>{
                                    if(!isSucceed){
                                        return false;
                                    }
                                    //初始化箱信息
                                    let containerImport = {
                                        bkContainerId: "",
                                        containerNo: "",
                                        containerType: "",
                                        sealNo1: "",
                                        sealNo2: "",
                                        sealNo3: "",
                                        sealNo4: "",
                                        quantity: "",
                                        weight: "",
                                        netWeight: "",
                                        containerWeight: "",
                                        cntrSize: "",
                                        cargoTypeCode: "",
                                        containerManager: "",
                                        hgType: "",
                                        hqToGpFlag: "",
                                        overWeightFlag: "",
                                        overWeight: "",
                                        rfDgFlag: ""
                                    };
                                    try {
                                        for(var key in item){
                                            if(key === "序号\nNo."){
                                                continue;
                                            }else if(key === "箱号\nContainer No"){
                                                containerImport.containerNo =item[key].trim().toUpperCase();
                                            }else if(key === "箱型尺寸\nSize/Type"){
                                                containerImport.containerType =item[key].trim().toUpperCase();
                                            }else if(key === "箱管理人\nCNTR Manager"){
                                                // 箱管理人需与提单SOC标志匹配。若提单勾选了SOC，则箱管理人只能是SOC，否则，箱管理人为ZGL
                                                // containerImport.containerManager =item[key].trim().toUpperCase();
                                                containerImport.containerManager = this.bookingHead.socCheckFlag ? 'SOC' : 'ZGL';
                                            }else if(key === "封签号\nSeal No1"){
                                                containerImport.sealNo1 =(item[key]+'').trim().toUpperCase();
                                            }else if(key === "件数\nQuantity"){
                                                containerImport.quantity =item[key];
                                            }else if(key === "毛重(KGS)\nGross Weight(KGS)"){
                                                containerImport.weight =this.formatImportNumber(item[key],3);
                                            }else if(key === "净重(KGS)\nNet Weight(KGS)"){
                                                containerImport.netWeight =this.formatImportNumber(item[key],3);
                                            }else if(key === "箱皮重(KGS)\nTare Weight(KGS)"){
                                                containerImport.containerWeight = this.formatImportNumber(item[key],3) === "" ?
                                                    this.getContainerWeight(containerImport.containerType)
                                                    : this.formatImportNumber(item[key],3);
                                            }else if(key === "尺寸(CBM)\nSize(CBM)"){
                                                containerImport.cntrSize =this.formatImportNumber(item[key],3);
                                            }else if(key === "货物类型\nCargo Type"){
                                                containerImport.cargoTypeCode =this.getCargoTypeCode(item[key].trim().toUpperCase());
                                            }else if(key === "挂衣箱型\nHg Type"){
                                                containerImport.hgType =item[key].trim().toUpperCase();
                                            }else if(key === "高代平(Yes/No)\nHTGP"){
                                                containerImport.hqToGpFlag =item[key].trim().toUpperCase() === "YES";
                                            }else if(key === "超重(Yes/No)\nOverWeight Flag"){
                                                containerImport.overWeightFlag =item[key].trim().toUpperCase() === "YES";
                                            }else if(key === "超重重量\nOver Weight"){
                                                containerImport.overWeight =this.formatImportNumber(item[key],3);
                                            }else if(key === "冻危(Yes/No)\nRf Dg Flag"){
                                                containerImport.rfDgFlag =item[key].trim().toUpperCase() === "YES";
                                            }else{
                                                //模板错误
                                                throw new Error("EndForLine");
                                            }
                                        }
                                        importBkContainers.push(containerImport);
                                    } catch(e){
                                        importBkContainers = [];
                                        if (e.message === "EndForLine") {
                                            isSucceed = false;
                                        }else{
                                            isSucceed = false;
                                            this.showMessage(true, e, "error");
                                        }
                                    }
                                });
                                //导入箱信息弹框中展示
                                if(importBkContainers.length <= 0){
                                    this.showMessage(true, this.$t("message.parseError"), "error");
                                    return;
                                }
                                this.editBkContainers = [];
                                this.editDeleteBkContainers = [];
                                this.bkContainers.forEach((container)=>{
                                    this.editBkContainers.push(container);
                                });
                                importBkContainers.forEach((container) => {
                                    this.editBkContainers.push(container);
                                });
                                this.addContainerDataShow = true;
                                //上传成功之后，重置上传文件列表
                                this.$refs.upload.clearFiles();
                            }else{
                                this.showMessage(true, this.$t("message.noData2Parse"), "error");
                            }
                        });
                    } catch (e) {
                        this.showMessage(true, e, "error");
                    }
                }
            },
            readExcelToJson (file) {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        let data = new Uint8Array(e.target.result);
                        let XLSX = require('xlsx');
                        let workbook = XLSX.read(data, {
                            type: "array"
                        });
                        //将Excel 第一个sheet内容转为json格式
                        if(workbook.SheetNames.length > 0){
                            let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                            let json = XLSX.utils.sheet_to_json(worksheet);
                            resolve(json);
                        }else{
                            //未解析到数据
                            let json = [];
                            resolve(json);
                        }
                    };
                    reader.readAsArrayBuffer(file);
                });
            },
            formatImportNumber(number, decimals) {
                let formatNumber = "";
                if(number === ""){
                    return formatNumber;
                }
                //去掉非法字符
                number = (number + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                    .replace(/^\./g, '0.')
                    // 保证只有出现一个.而没有多个.
                    .replace(/\.{2,}/g, '.')
                    // 保证.只出现一次，而不能出现两次以上
                    .replace('.', '$#$')
                    .replace(/\./g, '')
                    .replace('$#$', '.');
                let strs = number.split('.');
                if (strs.length === 1) {
                    formatNumber = strs[0];
                } else if (strs.length > 1) {
                    if (strs[1].length > decimals) {
                        strs[1] = strs[1].substring(0, decimals);
                    }
                    formatNumber = strs.join('.');
                }
                return formatNumber;
            },

            /**
             * 提单类型 简称解释ToolTip
             */
            getFullMeaning(item) {
              const meanings = {
                '1': 'ORIGINAL BILL OF LADING',
                '2': 'SEA WAYBILL',
                '3': 'TELEX RELEASE B/L'
              };
              return localStorage.getItem('locale') == 'en' ? meanings[String(item.codeValue)] || "" : "";
            },

            /**
             * 将file对象转换为二进制
             */
            dataURLtoBlob(dataurl) {
                const arr = dataurl.split(',');
                const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new Blob([u8arr], {
                    type: mime
                })
            },
            excelTemplateDownload(){
                window.open('/api/booking/excelTemplateDownload','_parent')
            },
            /**
             * 箱信息传输至后端解析
             */
            handleUpload(param){
                // 校验上传文件类型
                try {
                    if (!this.validateFileTypeBeforeUpload(param.file)) {
                        throw new Error("EndForEach");
                    }
                } catch (e) {
                    if (e.message !== "EndForEach") {
                        this.showMessage(false, e, "error");
                    } else {
                        this.$message({
                            message: this.$t('bookingSpace.container.validateFileTypeFailed'),
                            type: 'warning'
                        });
                        return;
                    }
                }

                let fd = new FormData();
                fd.append('file', param.file); // 传文件

                // 开启加载组件
                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('common.uploading'),             // 加载动画的文字
                    spinner: 'el-icon-loading',                     // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;

                this.axios.post('/api/booking/bkContaierDataUpload', fd, {
                    headers: {'Content-Type': 'multipart/form-data','Accept-language': localStorage.getItem("locale")},//定义内容格式,很重要
                    timeout: 20000,
                }).then(response => {
                    let responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        let importBkContainers = response.data.object;
                        this.editBkContainers = [];
                        this.editDeleteBkContainers = [];
                        this.bkContainers.forEach((container)=>{
                            this.editBkContainers.push(container);
                        });
                        importBkContainers.forEach((container) => {
                            this.editBkContainers.push(container);
                        });

                        // 校验上传文件中的 containerManager 与系统判断的 ctnManager 是否一致，不一致则自动修正
                        this.validateContainerManager(this.editBkContainers);

                        this.addContainerDataShow = true;
                        //上传成功之后，重置上传文件列表
                        this.$refs.upload.clearFiles();
                    } else {
                      this.$alert(responseCode, this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton"),
                        dangerouslyUseHTMLString: true
                      });
                    }
                    that.loadingtuo.close();
                }).catch(error => {
                    if (error.data) {
                        let responseCode = error.data.backMessage;
                        this.showMessage(false, responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    that.loadingtuo.close();
                });
            },
            /**
             * 校验上传文件中的 containerManager 与系统判断的 ctnManager 是否一致
             * @param {Array} importBkContainers - 上传文件解析得到的箱信息数组
             * @param {String} ctnManager - 系统判断的箱管理人（'SOC' 或 'ZGL'）
             */
            validateContainerManager(importBkContainers) {
                if (!importBkContainers || importBkContainers.length === 0) {
                    return;
                }

                // 根据提单SOC标志获取箱主
                let ctnManager = this.bookingHead.socCheckFlag ? 'SOC' : 'ZGL';

                // 收集 containerManager 与系统判断不一致的箱号
                const mismatchedContainers = [];

                importBkContainers.forEach((container) => {
                    // 检查上传文件中的 containerManager 是否与系统判断的 ctnManager 不一致
                    // 只有当 containerManager 不为空（不为 null、undefined、空字符串）且与系统判断不一致时，才需要提示
                    const uploadedManager = container.containerManager ? container.containerManager.trim() : '';
                    if (uploadedManager &&
                        uploadedManager.toUpperCase() !== ctnManager) {
                        if (uploadedManager !== '' && container.containerNo) {
                            mismatchedContainers.push(container.containerNo);
                        }

                        // 自动修正为系统判断的箱主
                        container.containerManager = ctnManager;
                    }
                });

                // // 如果有不一致的箱号，弹出提示
                // if (mismatchedContainers.length > 0) {
                //     // 将箱号列表格式化为 HTML，每行显示3个箱号，超出自动换行
                //     const formatContainerNos = (containers) => {
                //         const chunkSize = 3; // 每行显示的箱号数量
                //         const chunks = [];
                //         for (let i = 0; i < containers.length; i += chunkSize) {
                //             chunks.push(containers.slice(i, i + chunkSize));
                //         }
                //         // 每行用、连接，行与行之间用<br/>分隔
                //         return chunks.map(chunk => chunk.join('、')).join('<br/>');
                //     };
                //
                //     const formattedContainerNos = formatContainerNos(mismatchedContainers);
                //     let messageTemplate = '';
                //
                //     // 创建 Element UI 标签样式的 HTML
                //     const createTag = (text) => {
                //         // Element UI el-tag 样式
                //         const tagStyles = {
                //             theme: {
                //                 backgroundColor: '#fef0f0',
                //                 borderColor: '#fde2e2',
                //                 color: '#bc1920'
                //             },
                //             primary: {
                //                 backgroundColor: '#ecf5ff',
                //                 borderColor: '#ecf5ff',
                //                 color: '#409eff'
                //             },
                //             info: {
                //                 backgroundColor: '#f4f4f5',
                //                 borderColor: '#d3d4d6',
                //                 color: '#909399'
                //             },
                //             success: {
                //                 backgroundColor: '#f0f9ff',
                //                 borderColor: '#b3e5fc',
                //                 color: '#67c23a'
                //             }
                //         };
                //         const style = tagStyles.theme;
                //         return `<span style="display: inline-block; height: 24px; line-height: 22px; padding: 0 8px; font-size: 12px; border: 1px solid ${style.borderColor}; border-radius: 4px; background-color: ${style.backgroundColor}; color: ${style.color}; font-weight: 500; margin: 0 2px;">${text}</span>`;
                //     };
                //
                //     // 根据箱管理人类型选择标签样式
                //     const tagType = ctnManager === 'SOC' ? 'info' : 'primary';
                //     const containerManagerTag = createTag(ctnManager, tagType);
                //
                //     if (ctnManager === 'SOC') {
                //         // 系统判断为 SOC，但上传的不是 SOC
                //         messageTemplate = this.$t('message.containerManagerMismatchSOC', {
                //             containerNos: '{PLACEHOLDER}',
                //             containerManager: '{CONTAINER_MANAGER_TAG}'
                //         });
                //     } else {
                //         // 系统判断为 ZGL，但上传的不是 ZGL
                //         messageTemplate = this.$t('message.containerManagerMismatchZGL', {
                //             containerNos: '{PLACEHOLDER}',
                //             containerManager: '{CONTAINER_MANAGER_TAG}'
                //         });
                //     }
                //
                //     // 将占位符替换为标签样式的箱管理人
                //     messageTemplate = messageTemplate.replace('{CONTAINER_MANAGER_TAG}', containerManagerTag);
                //
                //     // 将占位符替换为格式化的箱号列表，固定高度显示3行，超出可滚动
                //     // 行高约1.5em，3行约4.5em，加上padding，总高度约80px
                //     const formattedContainerDiv = `<div style="height: 60px; overflow-y: auto; word-break: break-all; line-height: 1.5; font-size: 13px; margin: 10px 0; padding: 8px; background-color: #f5f7fa; border-radius: 4px; border: 1px solid #e4e7ed;">${formattedContainerNos}</div>`;
                //     const message = messageTemplate.replace('{PLACEHOLDER}', formattedContainerDiv);
                //
                //     // 使用确认框弹出提示，设置弹框宽度
                //     this.$alert(message, this.$t("common.tips"), {
                //         confirmButtonText: this.$t("common.okButton"),
                //         dangerouslyUseHTMLString: true,
                //         customClass: 'container-manager-alert'
                //     });
                // }
            },
            /**
             * 【箱信息excel上传】校验上传文件类型是否符合要求
             */
            validateFileTypeBeforeUpload(file) {
                var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
                // .jpg,.jpeg,.png,.pdf,.PDF
                const extension1 = testmsg === 'xls';
                const extension2 = testmsg === 'xlsx';
                // const isLt2M = file.size / 1024 / 1024 < 10
                return !(!extension1 &&
                    !extension2 );
            },

            /************************************ 集装箱弹框-毛重/箱皮重/尺寸 数字输入格式控制 ***********************************/
            dialogWeightFormatNumber(row, index) {
                if (this.bkContainers.length > 0 && row.weight !== "") {
                    this.bkContainers[index].weight = this.formatNumber(row.weight, 3);
                }
            },

            /**
             * 集装箱表格:根据货类代码获取货类名称
             */
            getCargoTypeName(cargoTypeCode) {
                let cargoTypeName = cargoTypeCode;
                try {
                    if (cargoTypeCode !== "") {
                        if (this.cargoTypeOptions.length <= 0) {
                            this.cargoTypeFocus();
                        }
                        this.cargoTypeOptions.forEach((item) => {
                            if (item.codeValue === cargoTypeCode) {
                                cargoTypeName = item.displayValueCn;
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return cargoTypeName;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
            },
            /**
             * 集装箱表格:根据货类名称匹配货类代码
             */
            getCargoTypeCode(cargoTypeName) {
                let cargoTypeCode = "";
                try {
                    if (cargoTypeName !== "") {
                        if (this.cargoTypeOptions.length <= 0) {
                            this.cargoTypeFocus();
                        }
                        this.cargoTypeOptions.forEach((item) => {
                            if (item.displayValueCn === cargoTypeName.trim() || item.displayValue === cargoTypeName.trim()) {
                                cargoTypeCode = item.codeValue;
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return cargoTypeCode;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
            },

            /************************************ 集装箱信息弹框-选择箱型自动带出箱皮重 ************************************/
            setContainerWeight(index, containerType) {
                try {
                    if (containerType !== "") {
                        if (this.containerTypeOptions.length <= 0) {
                            this.containerTypeFocus();
                        }
                        // console.log("选择箱型:", containerType);
                        this.containerTypeOptions.forEach((item) => {
                            if (item.equipmentCode === containerType) {
                                this.editBkContainers[index].containerWeight = item.tareWeight;
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message !== "EndForEach") {
                        this.showMessage(false, error, "error");
                    }
                }
            },
            getContainerWeight(containerType) {
                let containerWeight = 0;
                try {
                    if (containerType !== "") {
                        if (this.containerTypeOptions.length <= 0) {
                            this.containerTypeFocus();
                        }
                        this.containerTypeOptions.forEach((item) => {
                            if (item.equipmentCode === containerType.trim().toUpperCase()) {
                                // console.log(item.equipmentCode, item.tareWeight);
                                containerWeight = item.tareWeight;
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return containerWeight;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
            },

            /************************************ 集装箱信息弹框关闭监听 ***********************************
             * A.校验箱号、箱型（尺寸）、铅封号1、货类字段必填
             * B.校验件毛体是否与货物信息匹配
             */
            handleClose(done, type) {
                // console.log(done);
                if (this.editBkContainers.length > 0) {
                    //校验必填项是否非空
                    if(!this.validateEditBkContainer()){
                        return;
                    }

                    if(!this.validatePattern()){
                        return;
                    }

                    //校验箱号格式及是否重复
                    if(!this.validateContainerNo()){
                        return;
                    }

                    //校验HSCODE长度（有值时不能超过20个字符）
                    if(!this.validateHsCode()){
                        return;
                    }

                    //校验箱货件毛体是否匹配
                    let condition = this.bookingHead;
                    condition.bkCargos = [];
                    condition.bkCargos.push(this.bkCargo);
                    condition.bkContainers = this.editBkContainers;

                    //调用后端校验件毛体API
                    this.axios({
                        method: 'post',
                        url: '/api/booking/validateQGS',
                        data: condition,
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            //确定成功，将编辑后的值更新到箱信息表格
                            this.bkContainers = this.editBkContainers;
                            this.editDeleteBkContainers.forEach((deleteContainer)=>{
                                this.deleteBkContainers.push(deleteContainer);
                            });
                            if (type === 0) {
                                done();
                            } else {//点击确定按钮
                                this.addContainerDataShow = false;
                            }
                            this.editBkContainers = [];
                            this.editDeleteBkContainers = [];
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                } else {
                    if (type === 0) {
                        done();
                    } else {//点击确定按钮
                        this.addContainerDataShow = false;
                    }
                }
            },
            handleCancel() {
                this.editBkContainers = [];
                this.editDeleteBkContainers = [];
                this.addContainerDataShow = false;
            },

            /************************************ 危险品/冷箱输入保存校验 ***********************************
             * A.当订舱预配箱中存在货类为全危或冻货的记录时，特殊设置中对应危险品或冷箱复选框自动勾选，
             *   此时必须录入危险品或冷箱数据，在保存草稿及保存并发送船公司功能中增加危险品、冷箱信息录入校验，未录入数据时给出提示；
             * B.当订舱预配箱中不存在货类为全危或冻货的记录时，特殊设置中的危险品和冷箱复选框不允许勾选，
             *   取消勾选之前判断若存在数据，需先把数据记录清空
             */
            validateCargoTypeCode(value, index) {
                let rfFlag = false;
                let dgFlag = false;
                //校验是否选中货类为危险品或冷箱
                this.bkPreContainers.forEach((item) => {
                    if (item.cargoTypeCode === "0002") {//冻货
                        rfFlag = true;
                    } else if (item.cargoTypeCode === "0004") {//全危
                        dgFlag = true;
                    }
                });
                //自动设置危险品/冷箱复选框勾选状态
                if (!dgFlag && this.bkCargo.bkImos.length > 0) {//取消勾选时需判断原有的危险品信息是否清空
                    this.bkPreContainers[index].cargoTypeCode = "0004";
                    this.showMessage(false, this.$t("message.clearDgInfo"), "error");
                } else if (!rfFlag && this.bkCargo.bkReefers.length > 0) {//取消勾选时需判断原有的冷箱信息是否清空
                    this.bkPreContainers[index].cargoTypeCode = "0002";
                    this.showMessage(false, this.$t("message.clearRfInfo"), "error");
                } else {
                    // 校验当前特殊设置是否为只读状态，只读状态下不可修改
                    if(this.getReadOnlyFlag){
                        this.showMessage(false, this.$t("message.specialLocked"), "error");
                        this.bkPreContainers[index].cargoTypeCode = "";
                    }else{
                        this.bookingHead.dgCheckFlag = dgFlag;
                        this.bookingHead.rfCheckFlag = rfFlag;
                    }
                }
            },
            //复选框选中状态监听：货类为全危/冻货时，危险品/冷箱选中状态不可改变
            validatePreInfo(event, type) {
                // console.log(event);
                //校验是否录入了货类为全危的订舱预配箱信息
                if (type === 1) {
                    //获取点击之前复选框的勾选状态
                    let checked = this.bookingHead.dgCheckFlag;
                    try {
                        //根据订舱预配箱中录入的数据判断复选框是否要勾选
                        this.bookingHead.dgCheckFlag = false;
                        this.bkPreContainers.forEach((item) => {
                            if (item.cargoTypeCode === "0004") {
                                throw new Error("EndForEach");
                            }
                        });
                    } catch (e) {
                        if (e.message !== "EndForEach") {
                            this.showMessage(false, e, "error");
                        } else {
                            //存在货类为全危的订舱预配箱数据，设置危险品复选框为选中状态
                            this.bookingHead.dgCheckFlag = true;
                        }
                    }
                    //若点击之后不符合要求，需给出提示
                    if (this.bookingHead.dgCheckFlag === checked) {
                        this.showMessage(false,
                            checked ? this.$t("message.addDgInfoMsg")
                                : this.$t("message.addDgPreContainerInfoMsg"),
                            "warning");
                        event.returnValue = false;
                        return false;
                    }
                }
                //校验是否录入了货类为冻货的订舱预配箱信息
                if (type === 2) {
                    //获取点击之前复选框的勾选状态
                    let checked = this.bookingHead.rfCheckFlag;
                    try {
                        //根据订舱预配箱中录入的数据判断复选框是否要勾选
                        this.bookingHead.rfCheckFlag = false;
                        this.bkPreContainers.forEach((item) => {
                            if (item.cargoTypeCode === "0002") {
                                throw new Error("EndForEach");
                            }
                        });
                    } catch (e) {
                        if (e.message !== "EndForEach") {
                            this.showMessage(false, e, "error");
                        } else {
                            //存在货类为冻货的订舱预配箱数据，设置冷箱复选框为选中状态
                            this.bookingHead.rfCheckFlag = true;
                        }
                    }
                    //若点击之后不符合要求，需给出提示
                    if (this.bookingHead.rfCheckFlag === checked) {
                        this.showMessage(false,
                            checked ? this.$t("message.addRfInfoMsg")
                                : this.$t("message.addRfPreContainerInfoMsg"),
                            "warning");
                        event.returnValue = false;
                        return false;
                    }
                }
            },

            getPlaceHolder(defaultValue) {
                return this.bookingHead.blStatus == 1 ? '' : defaultValue;
            },

            /**
             * 校验换行是否允许，超过最大行数-1时，不允许换行
             * val：默认参数
             * content：输入内容
             * row：最大行数
             * length: 单行最大字符个数
             */
            validateKeyDown(val, content, row, length) {
                let rowArray = [];
                if (content != "") {
                    rowArray = content.split("\n");//获取单行数据
                }

                let event = window.event || arguments[0];
                // console.log(event,event.keyCode);
                if (event.key == 'Enter' || event.code == 'Enter' || event.keyCode == 13) {//回车键
                    //判断当前行数是否已达到最大行数
                    if (rowArray.length > 0) {
                        if (rowArray.length > row - 1) {//超过最大行数，则不允许换行
                            this.$message({
                                showClose: true,
                                message: val === 5 || val === 6 ?
                                    this.$t('message.charLengthLimitMsg2',
                                        {
                                            length: length,
                                            row: row
                                        }) :
                                    this.$t('message.charLengthLimitMsg',
                                        {
                                            length: length,
                                            row: row
                                        }),
                                type: 'error'
                            });
                            event.returnValue = false;
                            return false;
                        }
                    }
                }
            },

            /************************************ 【订舱预配箱】-新增、删除 按钮点击事件 ***********************************
             * 订舱预配箱-【新增】按钮点击
             */
            addBkPreContainer() {
                this.bkPreContainers.push({
                    bkPreContainerId: "",
                    containerType: "20GP",
                    quantity: "1",
                    cargoTypeCode: "0001"
                })
            },
            /**
             * 订舱预配箱-【删除】按钮点击：删除当前行订舱预配箱数据
             * 【新增2022/7/1】 删除订舱预配箱数据时判断：如果是全危或冻货，需要同时删除危险品或冷箱数据及取消特殊标志
             */
            removeBkPreContainer(i, j) {
                this.$confirm(this.$t("message.preContainerDeleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (i.bkPreContainerId !== null && i.bkPreContainerId !== "") {
                        //将该条记录加入到待删除订舱预配箱记录数组中
                        this.deleteBkPreContainers.push(this.bkPreContainers[j]);
                        this.bkPreContainers.splice(j, 1);
                    } else {
                        this.bkPreContainers.splice(j, 1);
                    }
                    // 判断是否需要清空特殊设置信息
                    if (i.cargoTypeCode === "0002") {//冻货
                        // 取消舱单冻货标志，清空冻货数据
                        this.bookingHead.rfCheckFlag = false;
                        this.bkCargo.bkReefers.forEach((reffer) => {
                            this.deleteBkReefers.push(reffer);
                        });
                        this.bkCargo.bkReefers = [];//清空冷箱信息
                    } else if (i.cargoTypeCode === "0004") {//全危
                        // 取消舱单危险品标志，清空危险品数据
                        this.bookingHead.dgCheckFlag = false;
                        this.bkCargo.bkImos.forEach((imo) => {
                            this.deleteBkImos.push(imo);
                        });
                        this.bkCargo.bkImos = [];//清空危险品信息
                    }
                })
            },

            /************************************ 【特殊设置】-新增、删除 按钮点击事件 ***********************************
             * 特殊设置-【新增】按钮点击
             */
            addArray(name) {
                switch (name) {
                    case "bkImos":
                        this.bkCargo.bkImos.push({
                            bkImoId: "",
                            classType: "",
                            unSeriseNo: "",
                            label: "",
                            packageDesc: "",
                            packageCode: "",
                            property: "",
                            componentDesc: "",
                            emergencySeq: "",
                            emergencyTelNo: "",
                            quantity: "",
                            grossWeight: "",
                            netWeight: "",
                            flashPoint: "",
                            rateBase: "",
                            isPolutionFlag: ""
                        });
                        break;
                    case "bkReefers":
                        this.bkCargo.bkReefers.push({bkReeferId: "", rateBase: "", temperature: "", intakeNum: "",})
                        break;
                    case "bkAks":
                        this.bookingHead.bkAks.push({
                            bkAkId: "",
                            containerType: "",
                            akLength: "",
                            akWidth: "",
                            akHigth: "",
                            akGrossWeight: ""
                        });
                        break;
                }
            },
            /**
             * 特殊设置-【删除】按钮点击
             */
            removeArray(name) {
                switch (name) {
                    case "bkImos":
                        this.removeBkImo();
                        break;
                    case "bkReefers":
                        this.removeBkReefer();
                        break;
                    case "bkAks":
                        this.removeBkAk();
                        break;
                }
            },
            /**
             * 危险品删除
             */
            removeBkImo() {
                if (this.bkCargo.bkImos.length === 0) {
                    return;
                }
                let index = this.bkCargo.bkImos.length - 1;
                let bkImoId = this.bkCargo.bkImos[index].bkImoId;
                this.$confirm(this.$t("message.imoDeleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (bkImoId !== null && bkImoId !== "") {
                        //将该条记录加入到待删除危险品记录数组中
                        this.deleteBkImos.push(this.bkCargo.bkImos[index]);
                        this.bkCargo.bkImos.splice(index, 1);
                    } else {
                        this.bkCargo.bkImos.splice(index, 1);
                    }
                })
                    .catch(action => {
                        //取消
                        if (action === 'cancel') {
                            console.log(action);
                        }
                    })
            },
            removeBkReefer() {
                if (this.bkCargo.bkReefers.length === 0) {
                    return;
                }
                let index = this.bkCargo.bkReefers.length - 1;
                let bkReeferId = this.bkCargo.bkReefers[index].bkReeferId;
                this.$confirm(this.$t("message.reeferDeleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (bkReeferId !== null && bkReeferId !== "") {
                        //将该条记录加入到待删除冷箱记录数组中
                        this.deleteBkReefers.push(this.bkCargo.bkReefers[index]);
                        this.bkCargo.bkReefers.splice(index, 1);
                    } else {
                        this.bkCargo.bkReefers.splice(index, 1);
                    }
                })
                    .catch(action => {
                        //取消
                        if (action === 'cancel') {
                            console.log(action);
                        }
                    })
            },
            removeBkAk() {
                if (this.bookingHead.bkAks.length === 0) {
                    return;
                }
                let index = this.bookingHead.bkAks.length - 1;
                let bkAkId = this.bookingHead.bkAks[index].bkAkId;
                this.$confirm(this.$t("message.akDeleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (bkAkId !== null && bkAkId !== "") {
                        //将该条记录加入到待删除特种箱记录数组中
                        this.deleteBkAks.push(this.bookingHead.bkAks[index]);
                        this.bookingHead.bkAks.splice(index, 1);
                    } else {
                        this.bookingHead.bkAks.splice(index, 1);
                    }
                })
                    .catch(action => {
                        //取消
                        if (action === 'cancel') {
                            console.log(action);
                        }
                    })
            },

            /************************************ 【集装箱信息】-新增、删除 按钮点击事件 ***********************************
             * 集装箱信息外层表格删除
             */
            removeContainerTableData(row, index) {
                if (!row) {
                    return;
                }

                this.$confirm(this.$t("message.containerDeleteConfirm") + row.containerNo + "?", this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (row.bkContainerId !== null && row.bkContainerId !== "") {
                        //将该条记录加入到待删除特种箱记录数组中
                        this.deleteBkContainers.push(this.bkContainers[index]);
                        this.bkContainers.splice(index, 1)
                    } else {
                        this.bkContainers.splice(index, 1)
                    }
                })

            },
            /**
             * SOC复选框变化处理
             * 当勾选SOC时，将所有集装箱的箱主改为SOC
             * 当取消勾选SOC时，将所有集装箱的箱主改为ZGL
             */
            handleSocCheckChange() {
                if (this.bkContainers && this.bkContainers.length > 0) {
                    const newContainerManager = this.bookingHead.socCheckFlag ? 'SOC' : 'ZGL';
                    this.bkContainers.forEach((container) => {
                        if (container) {
                            this.$set(container, 'containerManager', newContainerManager);
                        }
                    });
                }
            },
            /**
             * 集装箱信息外层表格编辑 --打开弹窗
             */
            editContainerTableData() {
                this.editBkContainers = [];
                this.editDeleteBkContainers = [];
                this.bkContainers.forEach((container)=>{
                    // 对象深拷贝，避免更新到bkContainer中的数据
                    let editContainer = JSON.parse(JSON.stringify(container));
                    this.editBkContainers.push(editContainer);
                });
                this.addContainerDataShow = true;
            },
            /**
             * 集装箱信息外层表格新增 --打开弹窗
             */
            addContainerTableData() {
                this.editBkContainers = [];
                this.editDeleteBkContainers = [];
                this.bkContainers.forEach((container)=>{
                    this.editBkContainers.push(container);
                });
                this.addContainerDataShow = true;
                this.addBkContainer();
            },
            /**
             * 集装箱弹窗内新增按钮点击
             */
            addBkContainer() {
                let q = this.bkCargo.quantity;
                let w = this.bkCargo.grossWeight;
                let s = this.bkCargo.cargoSize;
                try {
                    //统计当前已录入的集装箱信息的总件数、总毛重、总尺寸
                    this.editBkContainers.forEach((item) => {
                        if (item.quantity !== "") {
                            q = q - item.quantity;
                        }
                        if (item.weight !== "") {
                            w = w - item.weight;
                        }
                        if (item.cntrSize !== "") {
                            s = s - item.cntrSize;
                        }
                    });
                } catch (error) {
                    q = 0;
                    w = 0;
                    s = 0;
                }

                this.editBkContainers.push(
                    {
                        bkContainerId: "",
                        containerNo: "",
                        containerType: "",
                        sealNo1: "",
                        sealNo2: "",
                        sealNo3: "",
                        sealNo4: "",
                        quantity: q >= 0 ? q : 0,
                        weight: w >= 0 ? w : 0,
                        netWeight: 0,
                        containerWeight: 0,
                        cntrSize: s >= 0 ? s : 0,
                        cargoTypeCode: "0001",
                        containerManager: this.bookingHead.socCheckFlag ? "SOC" : "ZGL",
                        hgType: "",
                        hqToGpFlag: false,
                        overWeightFlag: false,
                        overWeight: "",
                        rfDgFlag: false,
                        cargoDesc: "",
                        hsCode: "",
                        classType: "",
                        unSerialNo: "",
                        reeferTemp: ""
                    }
                )
            },
            /**
             * 集装箱弹窗删除按钮点击
             */
            removeBkContainer(row, index) {
                if (!row) {
                    return;
                }

                this.$confirm(this.$t("message.containerDeleteConfirm") + row.containerNo + "?", this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (row.bkContainerId !== null && row.bkContainerId !== "") {
                        //将该条记录加入到待删除特种箱记录数组中
                        this.editDeleteBkContainers.push(this.editBkContainers[index]);
                        this.editBkContainers.splice(index, 1)
                    } else {
                        this.editBkContainers.splice(index, 1)
                    }
                })
            },

            /************************************ 底部按钮点击事件 ***********************************
             * 【保存】按钮点击
             */
            returnSave() {
                //校验必填字段是否不为空
                if (!this.validateNull()) {
                    return;
                }
                //校验货物中毛重不能小于净重
                if (!this.validateGrossAndNetWeight()) {
                    return;
                }
                //校验订舱预配箱是否有记录及货类是否不为空
                if (!this.validateBkPreContainer()) {
                    return;
                }

                // //校验箱信息非空字段不为空
                // if (!this.validateBkContainer()) {
                //     return;
                // }

                if (this.isSaveClick) {
                    return;
                }
                this.isSaveClick = true;
                const condition = this.returnCondition();
                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.saving'),        //加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;

                this.axios({
                    method: 'post',
                    url: '/api/booking/billOfLadingSave',
                    data: condition,
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    that.loadingtuo.close();//关闭进度条
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(false, this.responseCode, "success");
                        if (response.data.object !== null) {
                            // 刷新session中的数据
                            this.refreshSessionData(response.data.object);
                            this.setFieldValue(response.data.object);
                        }
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isSaveClick = false;
                }).catch(error => {
                    that.loadingtuo.close();//关闭进度条
                    this.isSaveClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }

                });
            },
            /**
             * 【发送船公司】按钮点击
             */
            returnSend() {
                if (this.isSendClick) {
                    return;
                }
                //校验必填字段是否不为空
                if (!this.validateNull()) {
                    return;
                }
                //校验货物中毛重不能小于净重
                if (!this.validateGrossAndNetWeight()) {
                    return;
                }
                //校验订舱预配箱是否有记录及货类是否不为空
                if (!this.validateBkPreContainer()) {
                    return;
                }
                //校验箱信息非空字段不为空
                if (!this.validateBkContainer()) {
                    return;
                }

                let that = this;
                const condition = this.returnCondition();

                // 正式提交SI前弹出确认对话框，告知客户提交后修改会收取改单费
                if (this.bookingHead.blStatus != null && this.bookingHead.blStatus !== 4) {
                    that.submitSI(condition);
                } else {
                    this.$confirm(this.$t('billOfLading.siSubmitConfirm'), this.$t("common.pleaseConfirm"), {
                        distinguishCancelAndClose: true,
                        confirmButtonText: this.$t("billOfLading.iConfirmed"),
                        cancelButtonText: this.$t("common.cancelButton")
                    }).then(() => {
                        // 用户点击确认，继续提交流程
                        that.submitSI(condition);
                    }).catch(action => {
                        // 用户点击取消或关闭，不进行提交
                        if (action === 'cancel') {
                            // 不做任何操作，用户可以保存草稿
                        }
                        if (action === 'close') {
                            // 不做任何操作，用户可以保存草稿
                        }
                    });
                }
            },
            /**
             * 提交SI补料的实际执行方法
             */
            submitSI(condition) {
                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.sending'),       //加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;

                //检验舱单锁定，则不允许修改
                this.axios({
                  method: 'post',
                  url: '/api/booking/validateIsModifiable4',
                  data: condition,
                  headers: {
                    'Accept-language': localStorage.getItem("locale")
                  }
                }).then(response => {
                  this.responseCode = response.data.backMessage;
                  if (response.data.backCode === "200") {
                      // 正式提交了SI之后，后续的修改都要收取改单费
                      if (this.bookingHead.blStatus != null && this.bookingHead.blStatus !== 4) {
                    // //当提单状态为提单确认状态时需要校验eta
                    // if (this.bookingHead.blStatus === 1||this.bookingHead.blStatus === 2) {
                      this.axios({
                        method: 'post',
                        url: '/api/booking/validateBlIsModifiable',
                        data: condition,
                        headers: {
                          'Accept-language': localStorage.getItem("locale")
                        }
                      }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {//允许修改,弹出修改付费提示
                          this.$confirm(this.responseCode, this.$t("common.pleaseConfirm"), {
                            distinguishCancelAndClose: true,
                            confirmButtonText: this.$t("common.confirmButton"),
                            cancelButtonText: this.$t("common.cancelButton")
                          }).then(() => {
                            //确认
                            this.isSendClick = true;
                            this.axios({
                              method: 'post',
                              url: '/api/booking/billOfLadingSend',
                              data: condition,
                              headers: {
                                'Accept-language': localStorage.getItem("locale")
                              }
                            }).then(response => {
                              this.responseCode = response.data.backMessage;
                              if (response.data.backCode === "200") {
                                if (response.data.object !== null) {
                                  // 刷新session中的数据
                                  this.refreshSessionData(response.data.object);
                                  this.setFieldValue(response.data.object);
                                }
                                this.showMessage(false, this.responseCode + this.$t("common.backAuto"), "success");
                                setTimeout(()=>{
                                  this.returnPage();
                                },2000);
                              } else {
                                this.showMessage(false, this.responseCode, "error");
                              }
                              that.loadingtuo.close();
                              this.isSendClick = false;
                            }).catch(error => {
                              that.loadingtuo.close();
                              this.isSendClick = false;
                              if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.showMessage(false, this.responseCode, "error");
                              } else {
                                this.showMessage(false, error, "error");
                              }
                            });

                          }).catch(action => {
                            //取消
                            if (action === 'cancel') {
                              that.loadingtuo.close();
                            }
                            if (action === 'close') {
                              that.loadingtuo.close();
                            }
                          })
                        } else {//不允许修改
                          this.showMessage(false, this.responseCode, "error");
                          that.loadingtuo.close();
                        }
                      }).catch(error => {
                        if (error.data) {
                          this.responseCode = error.data.backMessage;
                          this.showMessage(false, this.responseCode, "error");
                        } else {
                          this.showMessage(false, error, "error");
                        }
                        that.loadingtuo.close();
                      });
                    } else {

                      this.isSendClick = true;
                      this.axios({
                        method: 'post',
                        url: '/api/booking/billOfLadingSend',
                        data: condition,
                        headers: {
                          'Accept-language': localStorage.getItem("locale")
                        }
                      }).then(response => {
                        that.loadingtuo.close();
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                          if (response.data.object !== null) {
                            // 刷新session中的数据
                            this.refreshSessionData(response.data.object);
                            this.setFieldValue(response.data.object);
                          }
                          this.showMessage(false, this.responseCode + this.$t("common.backAuto"), "success");
                          setTimeout(()=>{
                            this.returnPage();
                          },2000);
                        } else {
                          this.showMessage(false, this.responseCode, "error");
                        }
                        this.isSendClick = false;
                      }).catch(error => {
                        that.loadingtuo.close();
                        this.isSendClick = false;
                        if (error.data) {
                          this.responseCode = error.data.backMessage;
                          this.showMessage(false, this.responseCode, "error");
                        } else {
                          this.showMessage(false, error, "error");
                        }
                      });
                    }
                  } else {//不允许修改
                    this.showMessage(false, this.responseCode, "error");
                    that.loadingtuo.close();
                  }
                }).catch(error => {
                  if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                  } else {
                    this.showMessage(false, error, "error");
                  }
                  that.loadingtuo.close();
                });
            },
            /**
             * 【返回】按钮点击
             */
            returnPage() {
                // this.$router.back(-1)
                window.opener = null;
                window.open("about:blank", "_top").close()
            },
            /**
             * 刷新session中的数据
             */
            refreshSessionData(bookingHeadInfo) {
                sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(bookingHeadInfo));
            },
            /**
             * 获取当前页面全部订舱数据 公共方法
             */
            returnCondition() {
                let condition = this.bookingHead;
                condition.bkRoutings = [];
                condition.bkCargos = [];
                condition.bkPreContainers = [];
                condition.bkContainers = [];
                condition.bkCustomers = [];
                condition.bkExtends = [];
                //舱单扩展信息
                condition.bkExtends.push(this.bkExtend);
                //货物信息
                let cargo = this.bkCargo;
                // 保存/发送前，清洗货描中的制表符为单个空格，避免后端或打印时出现不可见字符问题
                if (cargo && typeof cargo.cargoDesc === 'string') {
                    cargo.cargoDesc = cargo.cargoDesc.replace(/\t/g, ' ');
                }
                if (this.deleteBkImos.length > 0) {
                    this.deleteBkImos.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        cargo.bkImos.push(deleteItem);
                    })
                }
                if (this.deleteBkReefers.length > 0) {
                    this.deleteBkReefers.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        cargo.bkReefers.push(deleteItem);
                    })
                }
                condition.bkCargos.push(cargo);
                //特种箱信息
                condition.bkAks = this.bkAks;
                if (this.deleteBkAks.length > 0) {
                    this.deleteBkAks.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        condition.bkAks.push(deleteItem);
                    })
                }
                //设置客户信息
                //1.发货人
                let shipperCatalog = [];
                if (this.shipper.customerName !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.customerNameCatalogId,
                        sequence: 1,
                        catalogContent: this.shipper.customerName,
                        printFlag: this.shipper.customerNamePrintFlag
                    });

                }
                if (this.shipper.address !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.addressCatalogId,
                        sequence: 2,
                        catalogContent: this.shipper.address,
                        printFlag: this.shipper.addressPrintFlag
                    });
                }
                if (this.shipper.city !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.cityCatalogId,
                        sequence: 3,
                        catalogContent: this.shipper.city,
                        printFlag: this.shipper.cityPrintFlag
                    });
                }
                if (this.shipper.provinceCode !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.provinceCodeCatalogId,
                        sequence: 4,
                        catalogContent: this.shipper.provinceCode,
                        printFlag: this.shipper.provinceCodePrintFlag
                    });
                }
                if (this.shipper.provinceName !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.provinceNameCatalogId,
                        sequence: 5,
                        catalogContent: this.shipper.provinceName,
                        printFlag: this.shipper.provinceNamePrintFlag
                    });
                }
                if (this.shipper.postCode !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.postCodeCatalogId,
                        sequence: 6,
                        catalogContent: this.shipper.postCode,
                        printFlag: this.shipper.postCodePrintFlag
                    });
                }
                if (this.shipper.countryCode !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.countryCodeCatalogId,
                        sequence: 7,
                        catalogContent: this.shipper.countryCode,
                        printFlag: this.shipper.countryCodePrintFlag
                    });
                }
                if (this.shipper.tel !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.telCatalogId,
                        sequence: 8,
                        catalogContent: this.shipper.tel,
                        printFlag: this.shipper.telPrintFlag
                    });
                }
                if (this.shipper.email !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.emailCatalogId,
                        sequence: 9,
                        catalogContent: this.shipper.email,
                        printFlag: this.shipper.emailPrintFlag
                    });
                }
                if (this.shipper.enterpriseCode !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.enterpriseCodeCatalogId,
                        sequence: 11,
                        catalogContent: this.shipper.enterpriseCode,
                        printFlag: this.shipper.enterpriseCodePrintFlag
                    });
                }
                if(this.shipper.otherCatalogs.length > 0){
                    this.shipper.otherCatalogs.forEach((item) => {
                        shipperCatalog.push(item);
                    })
                }
                if (shipperCatalog.length > 0) {
                    //拼接打单内容
                    let shipperCompanyName = "";
                    shipperCatalog.forEach((item) => {
                        if (item.printFlag) {
                            shipperCompanyName = shipperCompanyName === "" ?
                                shipperCompanyName + item.catalogContent :
                                shipperCompanyName + "\n" + item.catalogContent;
                        }
                    });
                    //20221206gaolj
                  if(this.shipper.customerName!=this.initialCustomerName){
                    this.shipper.customerNameFlag = true;
                  }
                    condition.bkCustomers.push({
                        customerType: this.shipper.customerType,
                        bkCustomerId: this.shipper.bkCustomerId,
                        bookingHeadId: this.bookingHead.bookingHeadId,
                        companyName: shipperCompanyName,
                        bkCustomerCatalogs: shipperCatalog,
                        customerNameFlag:this.shipper.customerNameFlag
                    });
                }
                //2.收货人
                let consigneeCatalog = [];
                if (this.consignee.customerName !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.customerNameCatalogId,
                        sequence: 1,
                        catalogContent: this.consignee.customerName,
                        printFlag: this.consignee.customerNamePrintFlag
                    });
                }
                if (this.consignee.address !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.addressCatalogId,
                        sequence: 2,
                        catalogContent: this.consignee.address,
                        printFlag: this.consignee.addressPrintFlag
                    });
                }
                if (this.consignee.city !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.cityCatalogId,
                        sequence: 3,
                        catalogContent: this.consignee.city,
                        printFlag: this.consignee.cityPrintFlag
                    });
                }
                if (this.consignee.provinceCode !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.provinceCodeCatalogId,
                        sequence: 4,
                        catalogContent: this.consignee.provinceCode,
                        printFlag: this.consignee.provinceCodePrintFlag
                    });
                }
                if (this.consignee.provinceName !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.provinceNameCatalogId,
                        sequence: 5,
                        catalogContent: this.consignee.provinceName,
                        printFlag: this.consignee.provinceNamePrintFlag
                    });
                }
                if (this.consignee.postCode !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.postCodeCatalogId,
                        sequence: 6,
                        catalogContent: this.consignee.postCode,
                        printFlag: this.consignee.postCodePrintFlag
                    });
                }
                if (this.consignee.countryCode !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.countryCodeCatalogId,
                        sequence: 7,
                        catalogContent: this.consignee.countryCode,
                        printFlag: this.consignee.countryCodePrintFlag
                    });
                }
                if (this.consignee.tel !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.telCatalogId,
                        sequence: 8,
                        catalogContent: this.consignee.tel,
                        printFlag: this.consignee.telPrintFlag
                    });
                }
                if (this.consignee.email !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.emailCatalogId,
                        sequence: 9,
                        catalogContent: this.consignee.email,
                        printFlag: this.consignee.emailPrintFlag
                    });
                }
                if (this.consignee.enterpriseCode !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.enterpriseCodeCatalogId,
                        sequence: 15,
                        catalogContent: this.consignee.enterpriseCode,
                        printFlag: this.consignee.enterpriseCodePrintFlag
                    });
                }
                if(this.consignee.otherCatalogs.length > 0){
                    this.consignee.otherCatalogs.forEach((item) => {
                        consigneeCatalog.push(item);
                    })
                }
                if (consigneeCatalog.length > 0) {
                    //拼接打单内容
                    let consigneeCompanyName = "";
                    consigneeCatalog.forEach((item) => {
                        if (item.printFlag) {
                            consigneeCompanyName = consigneeCompanyName === "" ?
                                consigneeCompanyName + item.catalogContent :
                                consigneeCompanyName + "\n" + item.catalogContent;
                        }
                    });
                    condition.bkCustomers.push({
                        customerType: this.consignee.customerType,
                        bkCustomerId: this.consignee.bkCustomerId,
                        bookingHeadId: this.bookingHead.bookingHeadId,
                        companyName: consigneeCompanyName,
                        bkCustomerCatalogs: consigneeCatalog
                    });
                }
                //3.通知人1
                let notifier1Catalog = [];
                if (this.notifier1.customerName !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.customerNameCatalogId,
                        sequence: 1,
                        catalogContent: this.notifier1.customerName,
                        printFlag: this.notifier1.customerNamePrintFlag
                    });
                }
                if (this.notifier1.address !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.addressCatalogId,
                        sequence: 2,
                        catalogContent: this.notifier1.address,
                        printFlag: this.notifier1.addressPrintFlag
                    });
                }
                if (this.notifier1.city !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.cityCatalogId,
                        sequence: 3,
                        catalogContent: this.notifier1.city,
                        printFlag: this.notifier1.cityPrintFlag
                    });
                }
                if (this.notifier1.provinceCode !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.provinceCodeCatalogId,
                        sequence: 4,
                        catalogContent: this.notifier1.provinceCode,
                        printFlag: this.notifier1.provinceCodePrintFlag
                    });
                }
                if (this.notifier1.provinceName !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.provinceNameCatalogId,
                        sequence: 5,
                        catalogContent: this.notifier1.provinceName,
                        printFlag: this.notifier1.provinceNamePrintFlag
                    });
                }
                if (this.notifier1.postCode !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.postCodeCatalogId,
                        sequence: 6,
                        catalogContent: this.notifier1.postCode,
                        printFlag: this.notifier1.postCodePrintFlag
                    });
                }
                if (this.notifier1.countryCode !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.countryCodeCatalogId,
                        sequence: 7,
                        catalogContent: this.notifier1.countryCode,
                        printFlag: this.notifier1.countryCodePrintFlag
                    });
                }
                if (this.notifier1.tel !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.telCatalogId,
                        sequence: 8,
                        catalogContent: this.notifier1.tel,
                        printFlag: this.notifier1.telPrintFlag
                    });
                }
                if (this.notifier1.email !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.emailCatalogId,
                        sequence: 9,
                        catalogContent: this.notifier1.email,
                        printFlag: this.notifier1.emailPrintFlag
                    });
                }
                if (this.notifier1.enterpriseCode !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.enterpriseCodeCatalogId,
                        sequence: 15,
                        catalogContent: this.notifier1.enterpriseCode,
                        printFlag: this.notifier1.enterpriseCodePrintFlag
                    });
                }
                if(this.notifier1.otherCatalogs.length > 0){
                    this.notifier1.otherCatalogs.forEach((item) => {
                        notifier1Catalog.push(item);
                    })
                }
                if (notifier1Catalog.length > 0) {
                    //拼接打单内容
                    let notifier1CompanyName = "";
                    notifier1Catalog.forEach((item) => {
                        if (item.printFlag) {
                            notifier1CompanyName = notifier1CompanyName === "" ?
                                notifier1CompanyName + item.catalogContent :
                                notifier1CompanyName + "\n" + item.catalogContent;
                        }
                    });
                    condition.bkCustomers.push({
                        customerType: this.notifier1.customerType,
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bookingHeadId: this.bookingHead.bookingHeadId,
                        companyName: notifier1CompanyName,
                        bkCustomerCatalogs: notifier1Catalog
                    });
                }
                //4.通知人2
                let notifier2Catalog = [];
                if (this.notifier2.customerName !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.customerNameCatalogId,
                        sequence: 1,
                        catalogContent: this.notifier2.customerName,
                        printFlag: this.notifier2.customerNamePrintFlag
                    });
                }
                if (this.notifier2.address !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.addressCatalogId,
                        sequence: 2,
                        catalogContent: this.notifier2.address,
                        printFlag: this.notifier2.addressPrintFlag
                    });
                }
                if (this.notifier1.city !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.cityCatalogId,
                        sequence: 3,
                        catalogContent: this.notifier2.city,
                        printFlag: this.notifier2.cityPrintFlag
                    });
                }
                if (this.notifier2.provinceCode !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.provinceCodeCatalogId,
                        sequence: 4,
                        catalogContent: this.notifier2.provinceCode,
                        printFlag: this.notifier2.provinceCodePrintFlag
                    });
                }
                if (this.notifier2.provinceName !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.provinceNameCatalogId,
                        sequence: 5,
                        catalogContent: this.notifier2.provinceName,
                        printFlag: this.notifier2.provinceNamePrintFlag
                    });
                }
                if (this.notifier2.postCode !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.postCodeCatalogId,
                        sequence: 6,
                        catalogContent: this.notifier2.postCode,
                        printFlag: this.notifier2.postCodePrintFlag
                    });
                }
                if (this.notifier2.countryCode !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.countryCodeCatalogId,
                        sequence: 7,
                        catalogContent: this.notifier2.countryCode,
                        printFlag: this.notifier2.countryCodePrintFlag
                    });
                }
                if (this.notifier2.tel !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.telCatalogId,
                        sequence: 8,
                        catalogContent: this.notifier2.tel,
                        printFlag: this.notifier2.telPrintFlag
                    });
                }
                if (this.notifier2.email !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.emailCatalogId,
                        sequence: 9,
                        catalogContent: this.notifier2.email,
                        printFlag: this.notifier2.emailPrintFlag
                    });
                }
                if (this.notifier2.enterpriseCode !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.enterpriseCodeCatalogId,
                        sequence: 15,
                        catalogContent: this.notifier2.enterpriseCode,
                        printFlag: this.notifier2.enterpriseCodePrintFlag
                    });
                }
                if(this.notifier2.otherCatalogs.length > 0){
                    this.notifier2.otherCatalogs.forEach((item) => {
                        notifier2Catalog.push(item);
                    })
                }
                if (notifier2Catalog.length > 0) {
                    //拼接打单内容
                    let notifier2CompanyName = "";
                    notifier2Catalog.forEach((item) => {
                        if (item.printFlag) {
                            notifier2CompanyName = notifier2CompanyName === "" ?
                                notifier2CompanyName + item.catalogContent :
                                notifier2CompanyName + "\n" + item.catalogContent;
                        }
                    });
                    condition.bkCustomers.push({
                        customerType: this.notifier2.customerType,
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bookingHeadId: this.bookingHead.bookingHeadId,
                        companyName: notifier2CompanyName,
                        bkCustomerCatalogs: notifier2Catalog
                    });
                }
                //订舱预配箱信息
                let isEmpty = false;
                if (this.bkPreContainers.length > 0) {
                    this.bkPreContainers.forEach((item) => {
                        if (item.containerType !== "" || item.quantity !== "" || item.cargoTypeCode !== "") {
                            if (item.cargoTypeCode == "0014" || item.cargoTypeCode == "0018") {
                                //货类为“空箱0014”、“商品空箱0018”时，箱状态赋值为“空箱”；其余货类均赋值为“整箱”
                                isEmpty = true;
                            }
                            condition.bkPreContainers.push(item);
                        }
                    })
                }
                if (this.deleteBkPreContainers.length > 0) {
                    this.deleteBkPreContainers.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        condition.bkPreContainers.push(deleteItem);
                    })
                }
                //集装箱信息
                if (this.bkContainers.length > 0) {
                    this.bkContainers.forEach((item) => {
                        //根据订舱预配箱货类设置箱状态
                        if (item.containerNo !== "" || item.sealNo1 !== "" || item.sealNo2 !== "" || item.sealNo3 !== "" || item.sealNo4 !== ""
                            || item.quantity !== "" || item.weight !== "" || item.containerWeight !== "" || item.cntrSize !== ""
                            || item.cargoTypeCode !== "" || item.containerManager !== "") {
                            if (isEmpty) {
                                item.containerStatus = 4;//空箱
                            } else {
                                item.containerStatus = 8;//整箱
                            }
                            condition.bkContainers.push(item);
                        }
                        //设置高代平标志
                        if(item.hqToGpFlag === null || item.hqToGpFlag === ""){
                            item.hqToGpFlag = false;
                        }
                        //设置是否超重标志
                        if(item.overWeightFlag === null || item.overWeightFlag === ""){
                            item.overWeightFlag = false;
                        }
                        //设置是否冻危标志
                        if(item.rfDgFlag === null || item.rfDgFlag === ""){
                            item.rfDgFlag = false;
                        }
                    })
                }
                if (this.deleteBkContainers.length > 0) {
                    this.deleteBkContainers.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        condition.bkContainers.push(deleteItem);
                    })
                }
                //中转信息
                let tripNum = 0;
                let isD2F = false;//是否内转外舱单
                let isInternationalTransit = false;//是否国际中转
                if(this.bookingHead.transitPort !== ""
                    && this.bookingHead.transitPort !== this.bookingHead.pod){
                    isInternationalTransit = true;
                }
                //校验接货地与装货港是否相同
                if (this.bookingHead.por !== this.bookingHead.pol) {
                    this.bookingHead.tsFlag = true;
                    //生成前程运输信息
                    this.bkRoutingPre.tripNumber = ++tripNum;
                    this.bkRoutingPre.portFrom = this.bookingHead.por;
                    this.bkRoutingPre.portTo = this.bookingHead.pol;
                    this.bkRoutingPre.bookingStatus = 1;
                    if (this.bkRoutingPre.voyageNo === null || this.bkRoutingPre.voyageNo === "") {
                        this.bkRoutingPre.voyageNo = "T/S"; //航次未填写时默认为T/S
                    }
                    if(this.bkRoutingPre.outTransportType === null || this.bkRoutingPre.outTransportType === ""){
                        this.bkRoutingPre.outTransportType = 0; //出口运输类型未填写时默认为本港
                    }
                    if(this.bkRoutingPre.inTransportType === null || this.bkRoutingPre.inTransportType === ""){
                        this.bkRoutingPre.inTransportType = 0;      //进口运输类型未填写时默认为本港
                    }
                    if(this.bkRoutingPre.serviceLineCode === null || this.bkRoutingPre.serviceLineCode === ""){
                        this.bkRoutingPre.serviceLineCode = "T/S";  //航线未填写时默认为T/S
                    }
                    if(this.bkRoutingPre.vesselName === null || this.bkRoutingPre.vesselName === ""){
                        this.bkRoutingPre.vesselName = "T/S";       //船名称未填写时默认为T/S
                    }
                    if (this.bkRoutingPre.vesselCode === null || this.bkRoutingPre.vesselCode === "") {  //船名未填写时默认为T/S
                        this.bkRoutingPre.vesselCode = "T/S";
                    }
                    if (this.bkRoutingPre.carrier === null || this.bkRoutingPre.carrier === "") {     //承运人未填写时根据登录主体设置
                        this.bkRoutingPre.carrier = this.getCarrierByEntity;
                    }
                    //判断是否为内转外舱单
                    if(this.bkRoutingPre.carrier === "ZGI"){
                        isD2F = true;
                        this.bkRoutingPre.serviceLineCode = "DT/S";  //航线默认为DT/S,内转外航线
                        if(this.bkRoutingPre.voyageNo === "T/S"){
                            this.bkRoutingPre.voyageNo = "DT/S";    //若选择航次未T/S,自动设置为DT/S
                        }
                    }else {
                        this.bkRoutingPre.serviceLineCode = "T/S";  //航线默认为T/S,中转航线
                        if(this.bkRoutingPre.voyageNo === "DT/S"){
                            this.bkRoutingPre.voyageNo = "T/S";    //若选择航次未DT/S,自动调整为T/S
                        }
                    }
                    this.bkRoutingPre.voyageNo = this.bkRoutingPre.voyageNo.toUpperCase();
                    this.bkRoutingPre.carrier = this.bkRoutingPre.carrier.toUpperCase();
                    condition.bkRoutings.push(this.bkRoutingPre);
                }
                this.bkRouting1.tripNumber = ++tripNum;
                if(isD2F){
                    //内转外运输类型赋值为内转外
                    this.bkRouting1.outTransportType = 9;
                    //提单运输类型设置为内转外
                    condition.transportType = 9;
                }/*else{
                    //内转外运输类型赋值为本港
                    this.bkRouting1.outTransportType = 0;
                    //提单运输类型设置为本港
                    condition.transportType = 0;
                }*/
                // 一程干线起始港设置为舱单装货港
                this.bkRouting1.portFrom = this.bookingHead.pol;
                if(isInternationalTransit){
                    //如果存在国际中转，一程干线抵达港设置为接舱卸货港，即国际中转港
                    this.bkRouting1.portTo = this.bookingHead.transitPort;
                }else{
                    //不存在国际中转，抵达港即为舱单卸货港
                    this.bkRouting1.portTo = this.bookingHead.pod;
                }
                condition.bkRoutings.push(this.bkRouting1);

                //如果存在国际中转，则再增加一程干线
                if(isInternationalTransit){
                    //二程干线起始港设置为接舱卸货港，即为国际中转港
                    this.bkRoutingTransit.portFrom = this.bookingHead.transitPort;
                    //二程干线抵达港设置为舱单卸货港
                    this.bkRoutingTransit.portTo = this.bookingHead.pod;
                    if(this.bkRoutingTransit.outTransportType == null
                        || this.bkRoutingTransit.outTransportType == ""){
                        //出口运输类型设置为国际中转
                        this.bkRoutingTransit.outTransportType = 1;
                    }
                    if(this.bkRoutingTransit.inTransportType == null
                        || this.bkRoutingTransit.inTransportType == ""){
                        //进口运输类型默认为本港
                        this.bkRoutingTransit.inTransportType = 0;
                    }
                    if(this.bkRoutingTransit.vesselCode == null
                        || this.bkRoutingTransit.vesselCode == ""){
                        this.bkRoutingTransit.vesselCode = "TBA";
                    }
                    if(this.bkRoutingTransit.vesselName == null
                        || this.bkRoutingTransit.vesselName == ""){
                        this.bkRoutingTransit.vesselName = "TBA";
                    }
                    if(this.bkRoutingTransit.voyageNo == null
                        || this.bkRoutingTransit.voyageNo == ""){
                        this.bkRoutingTransit.voyageNo = "TBA";
                    }
                    if(this.bkRoutingTransit.voyageLeg == null
                        || this.bkRoutingTransit.voyageLeg == ""){
                        this.bkRoutingTransit.voyageLeg = "TBA";
                    }
                    if(this.bkRoutingTransit.carrier == null
                        || this.bkRoutingTransit.carrier == ""){
                        this.bkRoutingTransit.carrier = this.getCarrierByEntity;
                    }
                    if(this.bkRoutingTransit.serviceLineCode == null
                        || this.bkRoutingTransit.serviceLineCode == ""){
                        this.bkRoutingTransit.serviceLineCode = "T/S";
                    }
                    if(this.bkRoutingTransit.bookingStatus == null){
                        this.bkRoutingTransit.bookingStatus = 0;
                    }
                    this.bkRoutingTransit.lineType = 1;
                    this.bkRoutingTransit.tripNumber = ++tripNum;
                    if(this.bkRoutingTransit.isNoticedFlag == null){
                        this.bkRoutingTransit.isNoticedFlag = false;
                    }
                    this.bookingHead.tsFlag = true;
                    this.bookingHead.transportType = 1;
                    condition.bkRoutings.push(this.bkRoutingTransit);
                }

                if (this.bookingHead.del !== this.bookingHead.pod) {
                    this.bookingHead.tsFlag = true;
                    //生成默认的后程运输信息
                    this.bkRoutingNext.tripNumber = ++tripNum;
                    this.bkRoutingNext.portFrom = this.bookingHead.pod;
                    this.bkRoutingNext.portTo = this.bookingHead.del;
                    this.bkRoutingNext.bookingStatus = 1;
                    if (this.bkRoutingNext.outTransportType === null || this.bkRoutingNext.outTransportType === "") {
                        this.bkRoutingNext.outTransportType = 0;//出口运输类型为空则默认为本港
                    }
                    if (this.bkRoutingNext.inTransportType === null || this.bkRoutingNext.inTransportType === "") {
                        this.bkRoutingNext.inTransportType = 0;//进口运输类型为空默认为本港
                    }
                    if (this.bkRoutingNext.serviceLineCode === null || this.bkRoutingNext.serviceLineCode === "") {
                        this.bkRoutingNext.serviceLineCode = "T/S";
                    }
                    if (this.bkRoutingNext.vesselName === null || this.bkRoutingNext.vesselName === "") {
                        this.bkRoutingNext.vesselName = "T/S";
                    }
                    if (this.bkRoutingNext.vesselCode === null || this.bkRoutingNext.vesselCode === "") {
                        this.bkRoutingNext.vesselCode = "T/S";
                    }
                    if (this.bkRoutingNext.voyageNo === null || this.bkRoutingNext.voyageNo === "") {
                        this.bkRoutingNext.voyageNo = "T/S";
                    }
                    this.bkRoutingNext.carrier = this.getCarrierByEntity;
                    condition.bkRoutings.push(this.bkRoutingNext);
                }
                return condition;
            },
            getCompanyName(customerCatalogs) {
                let companyName = "";
                if (customerCatalogs.length > 0) {
                    customerCatalogs.forEach((item) => {
                        if (item.printFlag) {
                            companyName = companyName === "" ?
                                item.catalogContent :
                                companyName + "\n" + item.catalogContent;
                        }
                    });
                    return companyName;
                }
            },

            validateNull() {
                //订舱号
                if (this.bookingHead.bkNo === "") {
                    this.showMessage(false, this.$t("message.bkNoNotNull"), "error");
                    return false;
                }
                //接货地
                if (this.bookingHead.por === "") {
                    this.showMessage(false, this.$t("message.porNotNull"), "error");
                    return false;
                }
                //目的地
                if (this.bookingHead.del === "") {
                    this.showMessage(false, this.$t("message.delNotNull"), "error");
                    return false;
                }
                //运输条款
                if (this.bookingHead.transportationTerms === "") {
                    this.showMessage(false, this.$t("message.transportationTermsNotNull"), "error");
                    return false;
                }
                //付费方式
                if (this.bookingHead.paidType === "") {
                    this.showMessage(false, this.$t("message.paidTypeNotNull"), "error");
                    return false;
                }
                //询价单位
                if (this.bkExtend.applicantUnit === "") {
                    this.showMessage(false, this.$t("message.applicationUnitNotNull"), "error");
                    return false;
                } else {
                    // 获取当前询价单位填写内容的长度
                    let applicantUnitLength = this.getApplicantUnitLength(this.bkExtend.applicantUnit);
                    if (applicantUnitLength > 20) {
                        this.showMessage(false, this.$t('message.applicationUnitLengthWarn',{charLength: applicantUnitLength}), "error");
                        return false;
                    }
                }
                //提单类型
                if (this.bookingHead.deliveryDocumentMethod === "") {
                    this.showMessage(false, this.$t("message.deliveryDocumentMethodNotNull"), "error");
                    return false;
                }
                //签单地点
                if (this.bookingHead.deliveryDocumentPlace === "") {
                    this.showMessage(false, this.$t("message.deliveryDocumentPlaceNotNull"), "error");
                    return false;
                }
                //接货地描述
                if (this.bkExtend.porName === "") {
                    this.showMessage(false, this.$t("message.porNameNotNull"), "error");
                    return false;
                }
                //装货港描述
                if (this.bkExtend.polName === "") {
                    this.showMessage(false, this.$t("message.polNameNotNull"), "error");
                    return false;
                }
                //卸货港描述
                if (this.bkExtend.podName === "") {
                    this.showMessage(false, this.$t("message.podNameNotNull"), "error");
                    return false;
                }
                //目的地描述
                if (this.bkExtend.delName === "") {
                    this.showMessage(false, this.$t("message.delNameNotNull"), "error");
                    return false;
                }
                //货物信息尺寸不能为空20221213gaolj
                if (this.bkCargo.cargoSize === "") {
                    this.showMessage(false, this.$t("message.cargoInformationSizeNotNull"), "error");
                    return false;
                }
                // //针对海防的提单，收货人及通知人的联系电话必填
                // if (this.bookingHead.pod === "VNHPH") {
                //     // 如果填写了收货人信息，收货人联系电话不能为空
                //     if (this.consignee.customerName && this.consignee.customerName.trim() !== "") {
                //         if (!this.consignee.tel || this.consignee.tel.trim() === "") {
                //             this.showMessage(false, this.$t("message.consigneeAndNotifierTelNotNull"), "error");
                //             return false;
                //         }
                //     }
                //
                //     // 如果填写了通知人1信息，通知人1联系电话不能为空
                //     if (this.notifier1.customerName && this.notifier1.customerName.trim() !== "") {
                //         if (!this.notifier1.tel || this.notifier1.tel.trim() === "") {
                //             this.showMessage(false, this.$t("message.consigneeAndNotifierTelNotNull"), "error");
                //             return false;
                //         }
                //     }
                //
                //     // 如果填写了通知人2信息，通知人2联系电话不能为空
                //     if (this.notifier2.customerName && this.notifier2.customerName.trim() !== "") {
                //         if (!this.notifier2.tel || this.notifier2.tel.trim() === "") {
                //             this.showMessage(false, this.$t("message.consigneeAndNotifierTelNotNull"), "error");
                //             return false;
                //         }
                //     }
                // }
                // 危险品非空校验
                let errorMsg = [];
                if (this.bookingHead.dgCheckFlag && this.bkCargo.bkImos.length > 0) {
                    this.bkCargo.bkImos.forEach((item, index) => {
                        // IMO Class必填
                        if (item.classType === null || item.classType === "") {
                            errorMsg.push(this.$t("message.classTypeNotNull", {index: index + 1}));
                        }
                        // UN No.必填
                        if (item.unSeriseNo === null || item.unSeriseNo === "") {
                            errorMsg.push(this.$t("message.unSeriseNoNotNull", {index: index + 1}));
                        }
                        // 包装种类必填
                        if (item.packageDesc === null || item.packageDesc === "") {
                            errorMsg.push(this.$t("message.packageDescNotNull", {index: index + 1}));
                        }
                        // 包装类型必填
                        if (item.packageCode === null || item.packageCode === "") {
                            errorMsg.push(this.$t("message.packageCodeNotNull", {index: index + 1}));
                        }
                        // 运输品名必填
                        if (item.property === null || item.property === "") {
                            errorMsg.push(this.$t("message.propertyNotNull", {index: index + 1}));
                        }
                        // 化学品名必填
                        if (item.componentDesc === null || item.componentDesc === "") {
                            errorMsg.push(this.$t("message.componentDescNotNull", {index: index + 1}));
                        }
                        // 应急措施编号必填
                        if (item.emergencySeq === null || item.emergencySeq === "") {
                            errorMsg.push(this.$t("message.emergencySeqNotNull", {index: index + 1}));
                        }
                    });
                }
                // 冷箱非空校验
                if (this.bookingHead.rfCheckFlag && this.bkCargo.bkReefers.length > 0) {
                    this.bkCargo.bkReefers.forEach((item, index) => {
                        // 单位必填
                        if (item.rateBase === null || item.rateBase === "") {
                            errorMsg.push(this.$t("message.rateBaseNotNull", {index: index + 1}));
                        }
                        // 温度必填
                        if (item.temperature === null || item.temperature === "") {
                            errorMsg.push(this.$t("message.temperatureNotNull", {index: index + 1}));
                        }
                        // 通风口必填
                        if (item.intakeNum === null || item.intakeNum === "") {
                            errorMsg.push(this.$t("message.intakeNumNotNull", {index: index + 1}));
                        }
                    });
                }
                if (errorMsg.length > 0) {
                    this.$message({
                                      dangerouslyUseHTMLString: true,
                                      message: errorMsg.join(' <br/><br/> '),
                                      type: 'error'
                                  });
                    return false;
                }

                return true;
            },
            /**
             * 获取询价单位长度
             * @param {string} value - 输入的值
             * @returns {boolean} - 是否通过验证
             */
            getApplicantUnitLength(value) {
                if (value == null || value.length <= 0)
                    return true;

                let length = 0;
                for (let i = 0; i < value.length; i++) {
                    // 使用正则判断是否为中文字符
                    if (/[\u4e00-\u9fa5]/.test(value[i])) {
                        length += 2;
                    } else {
                        length += 1;
                    }
                }
                return length;
            },
            /*
             * 校验货物信息中毛重不能小于净重
             */
            validateGrossAndNetWeight() {
                // 获取毛重
                const grossWeight = parseFloat(this.bkCargo.grossWeight);
                // 获取净重
                const netWeight = parseFloat(this.bkCargo.netWeight);

                // 只有当毛重和净重都有值时才进行校验
                if (!isNaN(grossWeight) && !isNaN(netWeight)) {
                    if (grossWeight < netWeight) {
                        this.showMessage(false, this.$t("message.grossWeightLessThanNetWeight"), "error");
                        return false;
                    }
                }
                return true;
            },
            validateBkPreContainer() {
                let dgFlag = false;
                let rfFlag = false;
                let isEmpty = false;
                //校验是否有订舱预配箱记录
                if (this.bkPreContainers.length <= 0) {
                    this.showMessage(false, this.$t("message.noBkPreContainer"), "error");
                    return false;
                }

                this.bkPreContainers.forEach((item, index) => {
                    if (item.cargoTypeCode === "") {
                        this.showMessage(false, this.$t("message.noCargoTypeCode", {index: index}), "error");
                        return false;
                    }
                    //判断订舱预配箱信息中是否包含货类为全危或冻货的信息
                    if (item.cargoTypeCode === "0004") {
                        dgFlag = true;
                    }
                    if (item.cargoTypeCode === "0002") {
                        rfFlag = true;
                    }
                    //判断是否为重箱
                    if (item.cargoTypeCode === "0014" || item.cargoTypeCode === "0018") {
                        isEmpty = true;
                    }
                });

                //当订舱预配箱信息中存在货类为全危或冻货的信息时，校验是否添加了危险品/冷箱信息
                if (dgFlag && this.bkCargo.bkImos.length <= 0) {
                    this.showMessage(false, this.$t("message.addDgInfoMsg"), "error");
                    return false;
                }
                if (rfFlag && this.bkCargo.bkReefers.length <= 0) {
                    this.showMessage(false, this.$t("message.addRfInfoMsg"), "error");
                    return false;
                }
                // add by liyan 2022/11/2 下货纸里货类除了空箱、商品空箱外 HSCODE必填
                if (!isEmpty && (this.bookingHead.hsCode == null
                    || this.bookingHead.hsCode === "")) {
                    this.showMessage(false, this.$t("message.hsCodeNotNull"), "error");
                    return false;
                }
                return true;
            },
            validateBkContainer() {
                //校验是否有集装箱记录
                if (this.bkContainers.length <= 0) {
                    this.showMessage(false, this.$t("message.noBkContainer"), "error");
                    return false;
                }
                let errorMsg = [];
                let serviceLineCode = this.bookingHead.serviceLineCode;
                this.bkContainers.forEach((item, index) => {
                    //校验箱号是否非空
                    if (item.containerNo == null || item.containerNo === "") {
                        errorMsg.push(this.$t("message.containerNo", {index: index + 1}));
                    }
                    //校验箱型是否非空
                    if (item.containerType == null || item.containerType === "") {
                        errorMsg.push(this.$t("message.containerType", {index: index + 1}));
                    }
                    //校验货类是否非空
                    if (item.cargoTypeCode == null || item.cargoTypeCode === "") {
                        errorMsg.push(this.$t("message.noCargoTypeCode2", {index: index + 1}));
                    } else if (item.cargoTypeCode.trim() !== '0018' && item.cargoTypeCode.trim() !== '0014') {
                        //非空箱：校验铅封号1是否非空
                        if (item.sealNo1 == null || item.sealNo1 === "") {
                            errorMsg.push(this.$t("message.sealNo1", {index: index + 1}));
                        }
                    }
                    //校验箱主是否非空
                    if (item.containerManager == null || item.containerManager === "") {
                        errorMsg.push(this.$t("message.containerManager", {index: index + 1}));
                    }
                    //校验货名是否非空
                    if (item.cargoDesc == null || item.cargoDesc === "") {
                        errorMsg.push(this.$t("message.cargoDesc", {index: index + 1, serviceLineCode: serviceLineCode}));
                    }
                    //校验HS CODE是否非空
                    if (item.hsCode == null || item.hsCode === "") {
                        errorMsg.push(this.$t("message.hsCode", {index: index + 1, serviceLineCode: serviceLineCode}));
                    }
                    //校验货类为全危时，IMDG CLASS和UN NO.不能为空
                    if (item.cargoTypeCode === "0004") {
                        if (item.classType == null || item.classType === "") {
                            errorMsg.push(this.$t("message.classType", {index: index + 1, serviceLineCode: serviceLineCode}));
                        }
                        if (item.unSerialNo == null || item.unSerialNo === "") {
                            errorMsg.push(this.$t("message.unSerialNo", {index: index + 1, serviceLineCode: serviceLineCode}));
                        }
                    }
                    // 校验货类为冻货时，REEFER TEMP不能为空
                    if (item.cargoTypeCode === "0002") {
                        if (item.reeferTemp == null || item.reeferTemp === "") {
                            errorMsg.push(this.$t("message.reeferTemp", {index: index + 1, serviceLineCode: serviceLineCode}));
                        }
                    }
                });
                if (errorMsg.length > 0) {
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        message: errorMsg.join(' <br/><br/> '),
                        type: 'error'
                    });
                    return false;
                }
                return true;
            },
            validateEditBkContainer() {
                // 获取当前提单所属航线及目的港
                let serviceLineCode = this.bookingHead.serviceLineCode;
                let pod = this.bookingHead.pod;

                //获取下货纸中的货类
                let preContainerCargoType = [];
                let preContainerContainerType = [];
                this.bkPreContainers.forEach((item) => {
                    if(item.cargoTypeCode !== ""){
                        preContainerCargoType.push(item.cargoTypeCode);
                    }
                    if(item.containerType !== ""){
                        preContainerContainerType.push(item.containerType);
                    }
                })
                //校验是否有集装箱记录
                if (this.editBkContainers.length <= 0) {
                    this.showMessage(false, this.$t("message.noBkContainer"), "error");
                    return false;
                }
                let errorMsg = [];
                this.editBkContainers.forEach((item, index) => {
                    //校验箱号是否非空
                    if (item.containerNo == null || item.containerNo === "") {
                        errorMsg.push(this.$t("message.containerNo", {index: index + 1}));
                    }
                    //校验箱型是否非空
                    if (item.containerType == null || item.containerType === "") {
                        errorMsg.push(this.$t("message.containerType", {index: index + 1}));
                    }else{
                        //校验箱信息中箱型在下货纸中箱型是否存在
                        if(!preContainerContainerType.includes(item.containerType)){
                            errorMsg.push(this.$t("message.illegalContainerType", {index: index + 1, containerType: item.containerType}));
                        }
                    }
                    //校验货类是否非空
                    if (item.cargoTypeCode == null || item.cargoTypeCode === "") {
                        errorMsg.push(this.$t("message.noCargoTypeCode2", {index: index + 1}));
                    } else{
                        //校验箱信息中货类在下货纸中货类是否存在
                        if(!preContainerCargoType.includes(item.cargoTypeCode)){
                            errorMsg.push(this.$t("message.illegalCargoTypeCode",
                                {index: index + 1, cargoType: this.getCargoTypeName(item.cargoTypeCode)}));
                        } else if (item.cargoTypeCode.trim() !== '0018' && item.cargoTypeCode.trim() !== '0014') {
                            //非空箱：校验铅封号1是否非空
                            if (item.sealNo1 == null || item.sealNo1 === "") {
                                errorMsg.push(this.$t("message.sealNo1", {index: index + 1}));
                            }
                        }
                    }
                    //校验箱主是否非空
                    if (item.containerManager == null || item.containerManager === "") {
                        errorMsg.push(this.$t("message.containerManager", {index: index + 1}));
                    }
                    //检验箱主
                    if (item.containerManager != 'ZGL' && item.containerManager != 'SOC' && item.containerManager != '') {
                      errorMsg.push(this.$t("message.illegalContainerManager", {index: index + 1}));
                    }
                    //校验箱皮重是否非空
                    if (item.containerWeight == null || item.containerWeight === "") {
                        errorMsg.push(this.$t("message.containerWeight", {index: index + 1}));
                    }else{
                        //校验箱皮重是否不为0
                        if(parseFloat(item.containerWeight) == 0){
                            errorMsg.push(this.$t("message.containerWeightNotZero", {index: index + 1}));
                        }
                    }

                    // 若为指定港口，货名和HSCODE必填
                    // if (Array.isArray(this.cargoDescAndHscodeRequiredRouteList) && this.cargoDescAndHscodeRequiredRouteList.length > 0) {
                    //     // 校验数组中是否存在至少一个对象：serviceLineCode不为空、不为null/undefined
                    //     const hasValidServiceLine = this.cargoDescAndHscodeRequiredRouteList.some(item => {
                    //         return item?.codeValue === pod;
                    //     });
                    //
                    //     if (hasValidServiceLine) {
                            //校验货名是否非空
                            if (item.cargoDesc == null || item.cargoDesc === "") {
                                errorMsg.push(this.$t("message.cargoDesc", {index: index + 1, serviceLineCode: serviceLineCode}));
                            }
                            //校验HS CODE是否非空
                            if (item.hsCode == null || item.hsCode === "") {
                                errorMsg.push(this.$t("message.hsCode", {index: index + 1, serviceLineCode: serviceLineCode}));
                            }
                            //校验货类为全危时，IMDG CLASS和UN NO.不能为空
                            if (item.cargoTypeCode === "0004") {
                                if (item.classType == null || item.classType === "") {
                                    errorMsg.push(this.$t("message.classType", {index: index + 1, serviceLineCode: serviceLineCode}));
                                }
                                if (item.unSerialNo == null || item.unSerialNo === "") {
                                    errorMsg.push(this.$t("message.unSerialNo", {index: index + 1, serviceLineCode: serviceLineCode}));
                                }
                            }
                            // 校验货类为冻货时，REEFER TEMP不能为空
                            if (item.cargoTypeCode === "0002") {
                                if (item.reeferTemp == null || item.reeferTemp === "") {
                                    errorMsg.push(this.$t("message.reeferTemp", {index: index + 1, serviceLineCode: serviceLineCode}));
                                }
                            }
                    //     }
                    // }

                })
                if (errorMsg.length > 0) {
                    // this.$message({
                    //     dangerouslyUseHTMLString: true,
                    //     message: errorMsg.join(' <br/><br/> '),
                    //     type: 'error'
                    // });
                    this.$alert(errorMsg.join(' <br/> '), this.$t("common.tips"), {
                      confirmButtonText: this.$t("common.okButton"),
                      dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                return true;
            },
            validatePattern() {
                let errorMsg = [];
                var pattern = /^[A-Za-z]{4}\d{7}$/;
                this.editBkContainers.forEach((item, index) => {
                    if(item.containerNo !== ""){
                        if(!pattern.test(item.containerNo)){
                            errorMsg.push(this.$t("message.containerNoNoMatch", {index: index + 1,containerNo: item.containerNo}));
                        }
                    }
                });
                if (errorMsg.length > 0) {
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        message: errorMsg.join(' <br/><br/> '),
                        type: 'error'
                    });
                    return false;
                }
                return true;
            },
            validateContainerNo() {
                let errorMsg = [];
                let containerNos = [];
                this.editBkContainers.forEach((item, index) => {
                    if(item.containerNo !== ""){
                        if(containerNos.includes(item.containerNo)){
                            errorMsg.push(this.$t("message.containerNoDuplicated", {index: index + 1,containerNo: item.containerNo}));
                        }else{
                            containerNos.push(item.containerNo);
                        }
                    }
                });
                if (errorMsg.length > 0) {
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        message: errorMsg.join(' <br/><br/> '),
                        type: 'error'
                    });
                    return false;
                }
                return true;
            },
            //校验HSCODE长度：有值时不能超过20个字符（一般就是数字）。手动输入由输入框@input截断兜底，
            //但导入/回显等程序赋值不触发@input，需在点击确定时统一校验拦截
            validateHsCode() {
                let errorMsg = [];
                let maxLength = 20;
                this.editBkContainers.forEach((item, index) => {
                    if (item.hsCode && item.hsCode.length > maxLength) {
                        errorMsg.push(this.$t("message.hsCodeOverLength", {index: index + 1, maxLength: maxLength}));
                    }
                });
                if (errorMsg.length > 0) {
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        message: errorMsg.join(' <br/><br/> '),
                        type: 'error'
                    });
                    return false;
                }
                return true;
            },

            /************************************ 基础数据下拉赋值 ***********************************
             * 订舱状态
             */
            bookingStatusFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getBookingStatusList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.bookingStatusOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            getDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
            },
            /**
             * 订舱类型
             */
            bookingTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getBookingTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.bookingTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 提单类型
             */
            blTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getBlTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.blTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 运输条款
             */
            transportationTermsFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getServiceModeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.transportationTermsOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 付费方式
             */
            paidTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getPaidTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.paidTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 港口
             */
            portFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/port/getAllPortList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.portOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 承运人
             */
            carrierFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCarrierList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.carrierOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 货名及HSCODE必填航线信息
             */
            initCargoDescAndHscodeRequiredRoutes() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCargoDescAndHscodeRequiredRouteList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.cargoDescAndHscodeRequiredRouteList = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 货类
             */
            cargoTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCargoTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    // let cargoTypeMap = response.data.object;
                    // for (const key in cargoTypeMap) {
                    //     _this.cargoTypeOptions.push({value: key, label: cargoTypeMap[key]});
                    // }
                    _this.cargoTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 箱型
             */
            containerTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getContainerTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.containerTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 闪点单位
             */
            rateBaseFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getFlashPointRateBaseList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.rateBaseOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 危险品-包装种类
             */
            dgPackageGroupFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getDgPackagingGroupList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.dgPackageGroupOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /************************************ 货物包装类型弹出框 ***********************************
             * 弹框关闭按钮点击
             */
            closePopoverView() {
                this.$refs.packageTypePopover.showPopper = false;
            },
            /**
             * 弹框搜索按钮点击
             */
            packageTypeSearch() {
                if (this.isPopSearchClick) {
                    return;
                }
                this.isPopSearchClick = true;
                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),    //加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".packageTypePopover") // 设置加载动画区域
                });
                let that = this;
                this.axios({
                    method: 'post',
                    url: '/api/codedict/getPackageTypeList',
                    data: {
                        packageType: this.popover.packageType,
                        packageDesc: this.popover.packageDesc,
                        pageNum: this.popover.popPageNum,
                        pageSize: this.popover.popPageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    that.loadingtuo.close();
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.packageTypedata = response.data.object.list;
                        this.popover.popTotal = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isPopSearchClick = false;
                }).catch(error => {
                    that.loadingtuo.close();
                    this.isPopSearchClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            popHandleDemand() {
                this.packageTypeSearch();
            },
            /**
             * 包装类型弹框记录点击事件
             */
            popRowClick(row) {
                this.popover.popTableSelection = [row];
            },
            /**
             * 弹框确认按钮点击
             */
            popConfirm() {
                if (this.popover.popTableSelection.length !== 0) {//获取弹框中最后选中的记录
                    let row = this.popover.popTableSelection[0];
                    this.bkCargo.packageType = row.codeValue;
                    this.bkCargo.packageDesc = row.displayValue;
                }
                this.$refs.packageTypePopover.showPopper = false;
                this.popover.packageType = "";
                this.popover.packageDesc = "";
            },
            /**
             * 弹框分页参数改变事件
             */
            popHandleSizeChange(val) {
                this.popover.popPageNum = 1;
                this.popover.popPageSize = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },
            popHandleCurrentChange(val) {
                this.popover.popPageNum = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },

            /************************************ 页面数据初始化 ************************************/
            initPageInfo() {
                // if (this.$route.params == null) {
                //     return;
                // }
                // if (this.$route.params.bookingHeadInfo == null) {
                //     return;
                // }
                //
                // let bookingHeadInfo = this.$route.params.bookingHeadInfo;
                if(sessionStorage.getItem("PASSING_PARAMETERS") == null){
                    return;
                }
                let bookingHeadInfo = JSON.parse(sessionStorage.getItem("PASSING_PARAMETERS"));
                this.setFieldValue(bookingHeadInfo);
                // 初始化carrier值
                if (!this.bkRouting1.carrier || this.bkRouting1.carrier === "") {
                    this.bkRouting1.carrier = this.getCarrierByEntity;
                }
                
                // 初始化打印标志
                if(this.shipper.customerNamePrintFlag == null){
                    this.shipper.customerNamePrintFlag = true;
                }
                if(this.consignee.customerNamePrintFlag == null){
                    this.consignee.customerNamePrintFlag = true;
                }
                if(this.notifier1.customerNamePrintFlag == null){
                    this.notifier1.customerNamePrintFlag = true;
                }
                if(this.notifier2.customerNamePrintFlag == null){
                    this.notifier2.customerNamePrintFlag = true;
                }
            },

            setFieldValue(bookingHeadInfo) {
                // 清空待删除数据集合
                this.deleteBkImos = [];
                this.deleteBkReefers = [];
                this.deleteBkAks = [];
                this.deleteBkContainers = [];
                this.deleteBkPreContainers = [];

                this.bookingHead = bookingHeadInfo;
                if (bookingHeadInfo.bookingStatus || bookingHeadInfo.bookingStatus === 0) {
                    this.bookingHead.bookingStatus = bookingHeadInfo.bookingStatus.toString();
                }
                if (bookingHeadInfo.bookingType || bookingHeadInfo.bookingType === 0) {
                    this.bookingHead.bookingType = bookingHeadInfo.bookingType.toString();
                }
                if (bookingHeadInfo.paidType || bookingHeadInfo.paidType === 0) {
                    this.bookingHead.paidType = bookingHeadInfo.paidType.toString();
                }
                //【舱单扩展信息】
                let bkExtends = bookingHeadInfo.bkExtends;
                if (bkExtends.length > 0) {
                    this.bkExtend = bkExtends[0];
                }
                //【货物信息】
                let bkCargos = bookingHeadInfo.bkCargos;
                if (bkCargos.length > 0) {
                    this.bkCargo = bkCargos[0];
                }
                //【特种箱信息】
                this.bkAks = bookingHeadInfo.bkAks;
                //【中转信息】
                if (bookingHeadInfo.bkRoutings.length > 0) {
                    let bkRoutings = bookingHeadInfo.bkRoutings;
                    bkRoutings.forEach((item) => {
                        if (item.lineType === 1) {
                            if(item.portFrom === this.bookingHead.pol){
                                //赋值一程干线信息
                                this.bkRouting1 = item;
                                this.bookingHead.transitPort = item.portTo;
                            }else{
                                //赋值二程干线信息
                                this.bkRoutingTransit = item;
                            }
                        } else {
                            if (item.tripNumber === 1) {
                                this.bkRoutingPre = item;//前程运输信息
                            } else {
                                this.bkRoutingNext = item;//后程运输信息
                            }
                        }
                    })
                }
                //【订舱预配箱信息】
                this.bkPreContainers = bookingHeadInfo.bkPreContainers;
                //【集装箱信息】
                this.bkContainers = bookingHeadInfo.bkContainers;
                //【客户信息】
                let bkCustomers = bookingHeadInfo.bkCustomers;
                if (bkCustomers.length > 0) {
                    bkCustomers.forEach((item) => {
                        if (item.customerType === 0) {
                            //【发货人信息】
                            this.shipper.customerType = item.customerType;
                            this.shipper.bkCustomerId = item.bkCustomerId;
                            item.bkCustomerCatalogs.forEach((item) => {
                                if (item.sequence == 1) {
                                    this.shipper.customerName = item.catalogContent;
                                    this.initialCustomerName= item.catalogContent;//20221206gaolj
                                    this.shipper.customerNameCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.customerNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 2) {
                                    this.shipper.address = item.catalogContent;
                                    this.shipper.addressCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.addressPrintFlag = item.printFlag;
                                }else if (item.sequence == 3) {
                                    this.shipper.city = item.catalogContent;
                                    this.shipper.cityCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.cityPrintFlag = item.printFlag;
                                }else if (item.sequence == 4) {
                                    this.shipper.provinceCode = item.catalogContent;
                                    this.shipper.provinceCodeCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.provinceCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 5) {
                                    this.shipper.provinceName = item.catalogContent;
                                    this.shipper.provinceNameCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.provinceNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 6) {
                                    this.shipper.postCode = item.catalogContent;
                                    this.shipper.postCodeCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.postCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 7) {
                                    this.shipper.countryCode = item.catalogContent;
                                    this.shipper.countryCodeCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.countryCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 8) {
                                    this.shipper.tel = item.catalogContent;
                                    this.shipper.telCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.telPrintFlag = item.printFlag;
                                }else if (item.sequence == 9) {
                                    this.shipper.email = item.catalogContent;
                                    this.shipper.emailCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.emailPrintFlag = item.printFlag;
                                }else if (item.sequence == 11) {
                                    this.shipper.enterpriseCode = item.catalogContent;
                                    this.shipper.enterpriseCodeCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.enterpriseCodePrintFlag = item.printFlag;
                                } else{
                                    this.shipper.otherCatalogs.push(item);
                                }
                            })
                        } else if (item.customerType === 1) {
                            //【收货人信息】
                            this.consignee.customerType = item.customerType;
                            this.consignee.bkCustomerId = item.bkCustomerId;
                            item.bkCustomerCatalogs.forEach((item) => {
                                if (item.sequence == 1) {
                                    this.consignee.customerName = item.catalogContent;
                                    this.consignee.customerNameCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.customerNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 2) {
                                    this.consignee.address = item.catalogContent;
                                    this.consignee.addressCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.addressPrintFlag = item.printFlag;
                                }else if (item.sequence == 3) {
                                    this.consignee.city = item.catalogContent;
                                    this.consignee.cityCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.cityPrintFlag = item.printFlag;
                                }else if (item.sequence == 4) {
                                    this.consignee.provinceCode = item.catalogContent;
                                    this.consignee.provinceCodeCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.provinceCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 5) {
                                    this.consignee.provinceName = item.catalogContent;
                                    this.consignee.provinceNameCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.provinceNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 6) {
                                    this.consignee.postCode = item.catalogContent;
                                    this.consignee.postCodeCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.postCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 7) {
                                    this.consignee.countryCode = item.catalogContent;
                                    this.consignee.countryCodeCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.countryCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 8) {
                                    this.consignee.tel = item.catalogContent;
                                    this.consignee.telCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.telPrintFlag = item.printFlag;
                                }else if (item.sequence == 9) {
                                    this.consignee.email = item.catalogContent;
                                    this.consignee.emailCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.emailPrintFlag = item.printFlag;
                                }else if (item.sequence == 15) {
                                    this.consignee.enterpriseCode = item.catalogContent;
                                    this.consignee.enterpriseCodeCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.enterpriseCodePrintFlag = item.printFlag;
                                }else{
                                    this.consignee.otherCatalogs.push(item);
                                }
                            })
                        } else if (item.customerType === 2) {
                            //【通知人1信息】
                            this.notifier1.customerType = item.customerType;
                            this.notifier1.bkCustomerId = item.bkCustomerId;
                            item.bkCustomerCatalogs.forEach((item) => {
                                if (item.sequence == 1) {
                                    this.notifier1.customerName = item.catalogContent;
                                    this.notifier1.customerNameCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.customerNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 2) {
                                    this.notifier1.address = item.catalogContent;
                                    this.notifier1.addressCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.addressPrintFlag = item.printFlag;
                                }else if (item.sequence == 3) {
                                    this.notifier1.city = item.catalogContent;
                                    this.notifier1.cityCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.cityPrintFlag = item.printFlag;
                                }else if (item.sequence == 4) {
                                    this.notifier1.provinceCode = item.catalogContent;
                                    this.notifier1.provinceCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.provinceCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 5) {
                                    this.notifier1.provinceName = item.catalogContent;
                                    this.notifier1.provinceNameCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.provinceNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 6) {
                                    this.notifier1.postCode = item.catalogContent;
                                    this.notifier1.postCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.postCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 7) {
                                    this.notifier1.countryCode = item.catalogContent;
                                    this.notifier1.countryCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.countryCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 8) {
                                    this.notifier1.tel = item.catalogContent;
                                    this.notifier1.telCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.telPrintFlag = item.printFlag;
                                }else if (item.sequence == 9) {
                                    this.notifier1.email = item.catalogContent;
                                    this.notifier1.emailCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.emailPrintFlag = item.printFlag;
                                }else if (item.sequence == 15) {
                                    this.notifier1.enterpriseCode = item.catalogContent;
                                    this.notifier1.enterpriseCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.enterpriseCodePrintFlag = item.printFlag;
                                }else{
                                    this.notifier1.otherCatalogs.push(item);
                                }
                            })
                        } else {
                            //【通知人2信息】
                            this.notifier2.customerType = item.customerType;
                            this.notifier2.bkCustomerId = item.bkCustomerId;
                            item.bkCustomerCatalogs.forEach((item) => {
                                if (item.sequence == 1) {
                                    this.notifier2.customerName = item.catalogContent;
                                    this.notifier2.customerNameCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.customerNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 2) {
                                    this.notifier2.address = item.catalogContent;
                                    this.notifier2.addressCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.addressPrintFlag = item.printFlag;
                                }else if (item.sequence == 3) {
                                    this.notifier2.city = item.catalogContent;
                                    this.notifier2.cityCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.cityPrintFlag = item.printFlag;
                                }else if (item.sequence == 4) {
                                    this.notifier2.provinceCode = item.catalogContent;
                                    this.notifier2.provinceCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.provinceCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 5) {
                                    this.notifier2.provinceName = item.catalogContent;
                                    this.notifier2.provinceNameCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.provinceNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 6) {
                                    this.notifier2.postCode = item.catalogContent;
                                    this.notifier2.postCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.postCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 7) {
                                    this.notifier2.countryCode = item.catalogContent;
                                    this.notifier2.countryCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.countryCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 8) {
                                    this.notifier2.tel = item.catalogContent;
                                    this.notifier2.telCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.telPrintFlag = item.printFlag;
                                }else if (item.sequence == 9) {
                                    this.notifier2.email = item.catalogContent;
                                    this.notifier2.emailCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.emailPrintFlag = item.printFlag;
                                }else if (item.sequence == 15) {
                                    this.notifier2.enterpriseCode = item.catalogContent;
                                    this.notifier2.enterpriseCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.enterpriseCodePrintFlag = item.printFlag;
                                }else{
                                    this.notifier2.otherCatalogs.push(item);
                                }
                            })
                        }
                    })
                }
            },
            initCombos() {
                this.bookingTypeFocus();
                this.blTypeFocus();
                this.paidTypeFocus();
                this.portFocus();
                this.cargoTypeFocus();
                this.rateBaseFocus();
                this.containerTypeFocus();
                this.dgPackageGroupFocus();
                this.transportationTermsFocus();
                this.carrierFocus();
            },
        },
        mounted() {
        },
        created() {
            this.initCombos();
            // 初始化货名及HSCODE必填航线信息
            this.initCargoDescAndHscodeRequiredRoutes();
            this.initPageInfo();
            this.$parent.updateHeaderAside();
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/scss/base.scss";
    @import "../../assets/scss/public.scss";

    .el-row {
        margin-bottom: 0;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .el-col {
        margin-bottom: 0;
        border-radius: 4px;
    }

    .inputName-left {
        flex: 1;
        margin: 0 5px;
    }

    .packageTypeButton {
        width: 25px;
        height: 25px;
        margin-top: 2px;
    }

    .cardBox {
        background: $colorA;
        margin-bottom: 20px;
        border: 1px solid #e8e8e8;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        padding: 16px 16px 1px 16px;
    }

    .lastCardBox {
        width: 59.5%;
        margin-right: 0.5%;
        height: 80px;
    }

    .lastCardBox2 {
        width: 59.5%;
        height: 80px;
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .collapseTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .collapseItem {
        margin-top: -16px;
    }

    .setting {
        justify-content: flex-start;

        ul {
            li {
                margin-right: 15px;
                color: #6d7278;
                font-size: $fontB;
            }
        }
    }

    .position-right {
        height: 20px;
        text-align: right;
    }

    .topMargin {
        margin-top: 20px;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .inputName-title-left-textarea3 {
        height: 52px;
        line-height: 53px;
    }

    /deep/ .el-collapse-item__header {
        padding: 16px 16px 1px 16px;
    }

    /deep/ .el-collapse-item__content {
        padding: 16px 16px 1px 16px;
    }

    /deep/ .el-icon-arrow-right {
        border-radius: 50%;
        border: 2px solid #e8e8e8;
        color: #2867ce;
        font-size: $fontE;
        font-weight: 600;
    }

    .inputName {
        flex: 1;
        margin: 2px 5px;
        position: relative; // 为错误提示提供定位参考
    }

    //重写el-input样式，只显示下边框
    .inputName ::v-deep.el-input__inner{
        border-radius: 0;// 去掉圆角
        border-left-width: 0;
        border-right-width: 0;
        border-top-width: 0;
        border-bottom-width: 1px;//只显示下边框
    }

    .inputName ::v-deep.el-input.is-disabled .el-input__inner {
        background-color: #FFFFFF;
        border-color: #E4E7ED;
        color: black;
        cursor: not-allowed;
    }

    // 字段错误提示样式
    // 使用绝对定位，不影响原有组件的布局和位置
    .field-error-tip {
        position: absolute;
        top: 100%; // 显示在输入框下方
        right: 0; // 靠右侧显示
        color: #f56c6c;
        font-size: 10.5px;
        line-height: 1.5;
        margin-top: 1px;
        padding: 0;
        z-index: 10; // 确保显示在其他元素上方
        word-break: break-word;
        background: transparent; // 透明背景，不遮挡其他内容
        pointer-events: none; // 不阻挡鼠标事件，允许点击下方的元素
        white-space: normal; // 允许换行
        text-align: right; // 文本右对齐
        max-width: 100%; // 限制最大宽度，避免超出容器
    }

    // textarea 字符数显示样式（显示在 textarea 右下角）
    .textarea-word-limit {
        position: absolute;
        bottom: 5px;
        right: 10px;
        color: #909399;
        font-size: 12px;
        background: rgba(255, 255, 255, 0.9);
        padding: 2px 5px;
        border-radius: 2px;
        pointer-events: none;
        z-index: 1;
    }

    // 自定义字符数显示样式
    .custom-word-limit {
        color: #909399;
        font-size: 12px;
        padding-right: 8px;
    }

    // 箱管理人校验提示弹框样式
    ::v-deep .container-manager-alert {
        .el-message-box {
            width: 600px;
            max-width: 90vw;
        }
        .el-message-box__message {
            word-break: break-all;
        }
        // 箱号列表滚动区域样式
        .el-message-box__message div[style*="height: 80px"] {
            height: 80px !important;
            overflow-y: auto !important;
            // 自定义滚动条样式
            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
            }
            &::-webkit-scrollbar-thumb {
                background: #c1c1c1;
                border-radius: 3px;
                &:hover {
                    background: #a8a8a8;
                }
            }
        }
    }

    /*货名列：保留换行符展示（导入的货名含换行时按换行显示，而不是合并为一行）*/
    .cargo-desc-preline {
        white-space: pre-line;
        word-break: break-word;
    }

    /*弹框货名输入框：保持与单行输入框一致的固定高度（40px），换行内容超出时在框内滚动，避免撑高表格行*/
    .cargo-desc-textarea ::v-deep .el-textarea__inner {
        height: 40px;
        min-height: 40px;
        line-height: 28px;
    }
</style>
<style lang="scss">
    /*表格show-overflow-tooltip气泡内容保留换行：货名列多行内容超宽弹出气泡时仍按换行展示；
    行距缩小到1.2，避免气泡内多行内容行间距过大*/
    .el-tooltip__popper {
        white-space: pre-line;
        line-height: 1.2;
    }
</style>